<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert
          type="error"
          class="alert_all_page"
          v-if="alert_error === true"
          >{{ alert_message_error }}</v-alert
        >
        <v-alert
          type="success"
          class="alert_all_page"
          v-if="alert_success === true"
          >{{ alert_message_success }}</v-alert
        >
      </v-slide-x-reverse-transition>
      <v-row>
        <v-col xs="12" sm="6" md="9" lg="10" xl="10" cols="8">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">ระบบ POS</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="6" md="3" lg="2" xl="2" cols="4">
          <div class="ma-3 ml-0 text-right">
            <v-btn
              class="ma-2 ml-0 pl-3"
              type="button"
              outlined
              color="#D6BFAF"
              @click="open_customer = true"
              style="border-radius: 10px; background: #fff"
              large
            >
              <div class="d-flex align-center">
                <span class="pr-2" style="color: #616a6b; font-weight: 600">{{
                  username
                }}</span>
                <v-btn
                  elevation="2"
                  class="ma-2 ml-1"
                  outlined
                  color="#FEA06C"
                  title="แก้ไข"
                  small
                  style="
                    border-radius: 10px;
                    width: 35px !important;
                    min-width: 35px !important;
                  "
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" :class="colClass">
          <v-card
            elevation="2"
            style="border: 1px solid #d6bfaf; border-radius: 10px"
          >
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex justify-space-between align-center">
                    <div>
                      <h3>รายการสินค้า </h3>
                    </div>
                    <div>
                      <v-btn
                        v-if="round_status"
                        elevation="4"
                        class="ma-2"
                        outlined
                        color="#D6BFAF"
                        title="เปิดรอบการขาย"
                        small
                        height="38"
                        style="
                          font-size: 15px;
                          border-radius: 10px;
                          width: 150px !important;
                          min-width: 150px !important;
                        "
                        @click="dialog_open_pos = !dialog_open_pos"
                      >
                        เปิดรอบการขาย
                      </v-btn>
                      <v-btn
                        v-if="round_status"
                        elevation="4"
                        class="ma-2"
                        outlined
                        color="#D6BFAF"
                        title="จัดการร้านค้า"
                        small
                        height="38"
                        disabled
                        style="
                          border-radius: 10px;
                          width: 38px !important;
                          min-width: 38px !important;
                        "
                        @click="toggleColAndDiv"
                      >
                        <v-icon>mdi-view-grid-plus</v-icon>
                      </v-btn>
                      <v-btn
                        v-else
                        elevation="4"
                        class="ma-2"
                        outlined
                        color="#D6BFAF"
                        title="จัดการร้านค้า"
                        small
                        height="38"
                        style="
                          border-radius: 10px;
                          width: 38px !important;
                          min-width: 38px !important;
                        "
                        @click="toggleColAndDiv"
                      >
                        <v-icon>mdi-view-grid-plus</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-radio-group v-model="product_type_list">
                    <div class="d-flex" style="justify-content: right">
                      <v-radio
                        label="สินค้าปกติ"
                        :value="0"
                        class="mr-5"
                      ></v-radio>
                      <v-radio
                        label=" สินค้าใกล้หมดอายุ"
                        :value="1"
                        class="mb-2"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                  <input type="hidden" v-model="product_value" />
                  <v-autocomplete
                    v-if="round_status"
                    class="input-radius"
                    v-model="product_value"
                    autofocus="true"
                    clearable
                    @change="addItem"
                    :filter="customSearch"
                    spellcheck="false"
                    :items="productList"
                    item-value="barcode"
                    placeholder="ค้นหาสินค้า..."
                    single-line
                    solo
                    item-text="name"
                    outlined
                    dense
                  >
                    <template slot="selection" slot-scope="{ item }">
                      <span
                        >{{ item.name }} ({{ item.unit_name }}) ({{
                          item.barcode
                        }})</span
                      >
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      <v-list-tile-content>
                        <p class="fullName">
                          {{ item.name }} ({{ item.unit_name }}) ({{
                            item.barcode
                          }})
                        </p>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                  <!-- :search-input.sync="product_value" -->
                  
                  <v-autocomplete
                    v-else-if="isLoading"
                    class="input-radius"
                    v-model="value"
                    :search-input.sync="product_value"
                    @change="addItem" 
                    :filter="customSearch"
                    spellcheck="false"
                    :items="productList"
                    item-value="barcode"
                    placeholder="ยิงบาร์โค้ดหรือค้นหาสินค้า..."
                    single-line
                    solo
                    ref="product_list"
                    :autofocus="focus"
                    item-text="name"
                    outlined
                    dense
                  >
                    <template slot="selection" slot-scope="{ item }">
                      <span
                        >{{ item.name }} {{ item.name_sci }} ({{ item.unit_name }}) ({{
                          item.barcode
                        }})</span
                      >
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      <v-list-tile-content>
                        <p class="fullName">
                          {{ item.name }} {{ item.name_sci }} ({{ item.unit_name }}) ({{
                            item.barcode
                          }})
                        </p>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>

                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-simple-table
                    v-if="product_data.length < 7"
                    fixed-header
                    height="500px"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th style="font-size: 14px">ลบ</th>
                          <th style="font-size: 14px">บาร์โค๊ด</th>
                          <th style="font-size: 14px">ชื่อสินค้า</th>
                          <th style="font-size: 14px">คงเหลือ</th>
                          <th style="font-size: 14px; text-align: center">
                            จำนวน
                          </th>
                          <th style="font-size: 14px; text-align: center">
                            หน่วยนับ
                          </th>
                          <th style="font-size: 14px; text-align: right">
                            ราคา
                          </th>
                          <th style="font-size: 14px; text-align: center">
                            ส่วนลด
                          </th>
                          <th style="font-size: 14px; text-align: right">
                            ยอดรวม
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in product_data" :key="index">
                          <td class="hidden_line">
                            <v-btn
                              elevation="3"
                              outlined
                              x-small
                              height="45"
                              color="error"
                              title="ลบข้อมูล"
                              @click="removeProduct(index)"
                              style="
                                border-radius: 10px;
                                background-color: #ffffff;
                              "
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                          <td class="hidden_line">{{ item.barcode }}</td>
                          <td class="hidden_line">{{ item.name }}</td>
                          <td class="hidden_line">{{ item.in_stock }}</td>
                          <td class="hidden_line text-center">
                            <div
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-btn
                                class="mt-1"
                                color="#D6BFAF"
                                height="25px"
                                width="25px"
                                style="
                                  border-radius: 5px;
                                  border-color: #d6bfaf;
                                "
                                @click="
                                  subtractQuantity(index), calculate(index)
                                "
                                fab
                                x-small
                                dark
                                outlined
                              >
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                              <v-text-field
                                class="input-radius input-center mr-1 ml-1"
                                :class="widthClass"
                                type="text"
                                v-model="item.qty"
                                color="#D6BFAF"
                                value="1"
                                style="text-align: center"
                                @keypress="isNumber($event, item.qty)"
                                @change="calculate(index)"
                                @paste="isPaste($event)"
                                hide-details="auto"
                                single-line
                                solo
                                outlined
                                dense
                                required
                              >
                              </v-text-field>
                              <v-btn
                                class="mt-1"
                                color="#D6BFAF"
                                height="25px"
                                width="25px"
                                style="
                                  border-radius: 5px;
                                  border-color: #d6bfaf;
                                "
                                @click="addQuantity(index), calculate(index)"
                                fab
                                x-small
                                dark
                                outlined
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </td>
                          <td class="hidden_line text-center">
                            {{ item.unit_name }}
                          </td>
                          <td class="hidden_line text-right">
                            {{ formatPrice(item.price_standard) }}
                          </td>
                          <td
                            class="hidden_line text-center d-flex justify-center align-center"
                          >
                            <v-text-field
                              class="input-radius input-center"
                              type="number"
                              v-model="item.discount"
                              color="#D6BFAF"
                              @input="calculate(index)"
                              style="width: 10px; text-align: center"
                              placeholder="ส่วนลด"
                              @paste="isPaste($event)"
                              hide-details="auto"
                              single-line
                              solo
                              outlined
                              dense
                              required
                            >
                            </v-text-field>
                          </td>
                          <td class="hidden_line text-right">
                            {{ formatPrice(item.total_price) }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-simple-table v-else fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th style="font-size: 14px">ลบ</th>
                          <th style="font-size: 14px">บาร์โค๊ด</th>
                          <th style="font-size: 14px">ชื่อสินค้า</th>
                          <th style="font-size: 14px">คงเหลือ</th>
                          <th style="font-size: 14px; text-align: center">
                            จำนวน
                          </th>
                          <th style="font-size: 14px; text-align: center">
                            หน่วยนับ
                          </th>
                          <th style="font-size: 14px; text-align: right">
                            ราคา
                          </th>
                          <th style="font-size: 14px; text-align: center">
                            ส่วนลด
                          </th>
                          <th style="font-size: 14px; text-align: right">
                            ยอดรวม
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in product_data" :key="index">
                          <td class="hidden_line">
                            <v-btn
                              elevation="3"
                              outlined
                              small
                              height="45"
                              color="error"
                              title="ลบข้อมูล"
                              @click="removeProduct(index)"
                              style="
                                border-radius: 10px;
                                background-color: #ffffff;
                              "
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                          <td class="hidden_line">{{ item.barcode }}</td>
                          <td class="hidden_line">{{ item.name }}</td>
                          <td class="hidden_line">{{ item.in_stock }}</td>
                          <td class="hidden_line text-center">
                            <div
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-btn
                                class="mt-1"
                                color="#D6BFAF"
                                height="25px"
                                width="25px"
                                style="
                                  border-radius: 5px;
                                  border-color: #d6bfaf;
                                "
                                @click="
                                  subtractQuantity(index), calculate(index)
                                "
                                fab
                                x-small
                                dark
                                outlined
                              >
                                <v-icon>mdi-minus</v-icon>
                              </v-btn>
                              <v-text-field
                                class="input-radius input-center mr-1 ml-1"
                                :class="widthClass"
                                type="text"
                                v-model="item.qty"
                                color="#D6BFAF"
                                value="1"
                                style="text-align: center"
                                @keypress="isNumber($event, item.qty)"
                                @change="calculate(index)"
                                @paste="isPaste($event)"
                                hide-details="auto"
                                single-line
                                solo
                                outlined
                                dense
                                required
                              >
                              </v-text-field>
                              <v-btn
                                class="mt-1"
                                color="#D6BFAF"
                                height="25px"
                                width="25px"
                                style="
                                  border-radius: 5px;
                                  border-color: #d6bfaf;
                                "
                                @click="addQuantity(index), calculate(index)"
                                fab
                                x-small
                                dark
                                outlined
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </div>
                          </td>
                          <td class="hidden_line text-center">
                            {{ item.unit_name }}
                          </td>
                          <td class="hidden_line text-right">
                            {{ formatPrice(item.price_standard) }}
                          </td>
                          <td
                            class="hidden_line text-center d-flex justify-center align-center"
                          >
                            <v-text-field
                              class="input-radius input-center"
                              type="number"
                              v-model="item.discount"
                              color="#D6BFAF"
                              @input="calculate(index)"
                              style="width: 10px; text-align: center"
                              placeholder="ส่วนลด"
                              @paste="isPaste($event)"
                              hide-details="auto"
                              single-line
                              solo
                              outlined
                              dense
                              required
                            >
                            </v-text-field>
                          </td>
                          <td class="hidden_line text-right">
                            {{ formatPrice(item.total_price) }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="5" lg="5" xl="5" cols="12">
                  <!-- <div v-if="product_data.length > 0" class="d-flex align-center">
                    <span style="font-size: 16px; font-weight: 600" class="mr-2">เบอร์โทรสมาชิก/พนักงาน :
                    </span>
                    <v-autocomplete class="required--text input-radius" color="#D6BFAF" :items="memberList"
                      v-model="telephone" item-text="member_name" item-value="member_name"
                      placeholder="ค้นหาสมาชิกจากเบอร์โทรศัพท์/ชื่อสมาชิก" single-line dense outlined
                      hide-details="auto"></v-autocomplete>
                    <v-text-field class="input-radius" type="text" v-model="telephone" color="#D6BFAF"  @input="getCheckUser" hide-details="auto"></v-text-field>
                    <v-text-field class="input-radius" type="text" v-model="telephone" color="#D6BFAF"
                                            @keypress="isNumber($event, telephone)" @input="getCheckUser"
                                            @paste="isPaste($event)" hide-details="auto"
                                            placeholder="กรุณากรอกเบอร์โทรสมาชิก" single-line solo outlined dense required>
                                        </v-text-field>
                  </div> -->
                  <div class="d-flex align-center">
                    <span style="font-size: 16px; font-weight: 600" class="mr-2"
                      >เบอร์โทรสมาชิก/พนักงาน :
                    </span>
                    <v-autocomplete
                      class="required--text input-radius"
                      color="#D6BFAF"
                      :items="memberList"
                      v-model="telephone"
                      :item-text="formatItemText"
                      item-value="name"
                      @input="getCheckUser"
                      placeholder="ค้นหาสมาชิกจากเบอร์โทรศัพท์/ชื่อ"
                      single-line
                      dense
                      outlined
                      hide-details="auto"
                    ></v-autocomplete>
                    <!-- <v-text-field class="input-radius" type="text" v-model="telephone" color="#D6BFAF"  @input="getCheckUser" hide-details="auto"></v-text-field> -->
                    <!-- <v-text-field class="input-radius" type="text" v-model="telephone" color="#D6BFAF"
                                            @keypress="isNumber($event, telephone)" @input="getCheckUser"
                                            @paste="isPaste($event)" hide-details="auto"
                                            placeholder="กรุณากรอกเบอร์โทรสมาชิก" single-line solo outlined dense required>
                                        </v-text-field> -->
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12"></v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                  <div class="d-flex" style="justify-content: space-between">
                    <p
                      style="font-size: 18px; color: #b0886b; font-weight: 600"
                    >
                      ราคารวม
                    </p>
                    <p
                      style="font-size: 18px; color: #b0886b; font-weight: 600"
                    >
                      {{ formatPrice(summary - discount) }}
                    </p>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                  <div class="d-flex align-center">
                    <span style="font-size: 16px; font-weight: 600" class="mr-2"
                      >คุณ :
                      {{ customer_name == null ? "-" : customer_name }}</span
                    >
                  </div>
                  <div class="d-flex align-center">
                    <span style="font-size: 16px; font-weight: 600" class="mr-2"
                      >โน๊ต :
                      {{ customer_note == null ? "-" : customer_note }}</span
                    >
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12"></v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                  <div class="d-flex" style="justify-content: space-between">
                    <p style="font-size: 16px">รวมส่วนลดสินค้า</p>
                    <p style="font-size: 16px">{{ formatPrice(discount) }}</p>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12"></v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12"></v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                  <v-btn
                    block
                    elevation="0"
                    large
                    @click="saveData(0)"
                    v-if="product_data.length != 0"
                    :disabled="loading_page"
                    :loading="loading_page"
                    style="
                      background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),#88b358 !important;
                      border-radius: 10px;
                      color: #fff;
                      font-size: 16px;
                    "
                    >รับเงิน</v-btn
                  >
                  <v-btn
                    block
                    elevation="0"
                    large
                    v-else
                    style="
                      background: linear-gradient(90deg,#b0886b 0%,rgba(214, 191, 175, 0) 100%),#d6bfaf;
                      border-radius: 10px;
                      color: #fff;
                      font-size: 16px;
                    "
                    disabled
                    >รับเงิน</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="2" v-if="showHiddenDiv">
          <v-card
            elevation="2"
            style="border: 1px solid #d6bfaf; border-radius: 10px"
          >
            <v-card-text>
              <h3 style="color: #b0886b">จัดการการขาย </h3>
            </v-card-text>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="open_product = true"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/box_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>สินค้า</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="restart_pos = true"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/reset_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>เริ่มขายใหม่</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="open_drawer_menu = true"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/drawer_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>เปิดลิ้นชัก</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="dialog_register = true"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/register_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>สมัครสมาชิก</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <h3 style="color: #b0886b">จัดการบิล</h3>
            </v-card-text>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="stop_pos = true"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/bill_break_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>พักบิล</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="link('/arin/pos/posrecallbill/' + round_id)"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/call_bill_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>เรียกบิล</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="cancel_bill = true"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/cancel_bill_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>ยกเลิกบิล</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="clear_bill = true"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/clear_bill_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>ล้างบิล</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="link('/arin/pos/posbillsale/' + round_id)"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/bill_list_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>แสดงบิลขาย</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="6">
                  <v-card
                    style="border: 1px solid #d6bfaf; border-radius: 10px"
                    @click="openPOS()"
                  >
                    <v-card-text>
                      <center>
                        <v-img
                          class="mb-1"
                          src="@/assets/arin_assets/drawer_pos.png"
                          width="25"
                          height="25"
                        ></v-img>
                        <h4>จอสะท้อน</h4>
                      </center>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    @click="
                      link('/arin/pos/posinvoicesclosesummary/' + round_id)
                    "
                    block
                    elevation="0"
                    large
                    style="
                      background: linear-gradient(90deg,#da4142 0%,rgba(236, 97, 98, 0) 100%),#ec6162;
                      border-radius: 10px;
                      color: #fff;
                      font-size: 16px;
                    "
                    >ปิดร้าน</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- เลือกพนักงานขาย -->
      <v-dialog v-model="open_customer" persistent max-width="500">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>เลือกพนักงานขาย</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="open_customer = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                cols="12"
                class="py-1"
              >
                <v-list class="py-0">
                  <v-list-item-group color="#D6BFAF">
                    <h4>พนักงาน</h4>
                    <v-list-item
                      v-for="item in user_List"
                      :key="item.id"
                      class=""
                      @click="selectItem(item), (owner_id = null)"
                      :style="
                        user_id == item.id
                          ? 'background-color:#D6BFAF; box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);'
                          : ''
                      "
                    >
                      <v-icon style="font-size: 35px">mdi-account</v-icon>
                      <v-row>
                        <v-col cols="10">
                          <v-list-item-content
                            :class="
                              user_id == item.id
                                ? 'text_style_color-white'
                                : 'text_style_color'
                            "
                            >{{ item.name }}</v-list-item-content
                          >
                        </v-col>
                        <v-col cols="2 flex">
                          <div class="logo_branch position-fixed right-0">
                            <v-img
                              src="@/assets/arin_assets/check_active.png"
                            />
                          </div>
                        </v-col>
                      </v-row>
                      <!-- <div class="choice_branch py-0">
                                                <div>
                                                </div>
                                               
                                            </div> -->
                    </v-list-item>
                    <h4>เจ้าของร้าน</h4>
                    <v-list-item
                      class=""
                      @click="selectItem(owner_data), (user_id = null)"
                      :style="
                        owner_id == owner_data.owner_id
                          ? 'background-color:#D6BFAF; box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);'
                          : ''
                      "
                    >
                      <v-icon style="font-size: 35px">mdi-account</v-icon>
                      <v-row>
                        <v-col cols="10">
                          <v-list-item-content
                            :class="
                              owner_id == owner_data.owner_id
                                ? 'text_style_color-white'
                                : 'text_style_color'
                            "
                            >{{ owner_data.owner_name }}</v-list-item-content
                          >
                        </v-col>
                        <v-col cols="2 flex">
                          <div class="logo_branch position-fixed right-0">
                            <v-img
                              src="@/assets/arin_assets/check_active.png"
                            />
                          </div>
                        </v-col>
                      </v-row>
                      <!-- <div class="choice_branch py-0">
                                                <div>
                                                </div>
                                               
                                            </div> -->
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              class="btn_add_data_pop"
              elevation="4"
              @click="saveUser()"
              large
              >เลือกพนักงาน</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- เปิดรอบการขาย -->
      <v-dialog v-model="dialog_open_pos" persistent max-width="500">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>เปิดรอบการขาย</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="closeWindowPos">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-form ref="upload" @submit.prevent="init_store()">
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <center>
                    <v-img
                      width="150"
                      height="150"
                      src="@/assets/arin_assets/schedule.png"
                      class="preview mt-3 mb-2"
                    ></v-img>
                  </center>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >จำนวนเงินในลิ้นชัก
                      <span class="required--text">*</span></label
                    >
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-cash-multiple"
                      @keypress="isCurrency($event, init_money_amount)"
                      @paste="isPaste($event)"
                      hide-details="auto"
                      v-model="init_money_amount"
                      type="text"
                      :rules="[(v) => !!v || 'กรุณากรอกจำนวนเงินในลิ้นชัก']"
                      maxLength="7"
                      placeholder="กรุณากรอกจำนวนเงินในลิ้นชัก"
                      single-line
                      outlined
                      dense
                      required
                    >
                    </v-text-field>
                  </v-form-group>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn type="submit" class="btn_add_data_pop" elevation="4" large
                >เปิดรอบ</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- สิ้นสุดเปิดรอบการขาย -->
      <!-- สมัครสมาชิก -->
      <v-dialog v-model="dialog_register" persistent max-width="600">
        <v-form ref="register" @submit.prevent="saveRegister()">
          <v-card class="input-radius">
            <div class="d-flex justify-space-between">
              <v-card-title>
                <b>สมัครสมาชิก</b>
              </v-card-title>
              <v-btn
                icon
                class="ma-4"
                @click="(dialog_register = false), reset_all()"
              >
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >ชื่อ-สกุล <span class="required--text">*</span></label
                    >
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-account"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'กรุณากรอกชื่อ - สกุล']"
                      maxLength="255"
                      v-model="customer_register.fullname"
                      placeholder="กรุณากรอกชื่อ - สกุล"
                      single-line
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="10" xl="10" cols="12">
                  <label class="label_form_text">เบอร์โทร</label>
                  <v-otp-input
                    type="text"
                    color="#D6BFAF"
                    hide-details="auto"
                    v-model="customer_register.tel"
                    length="10"
                    @keypress="isNumber($event, customer_register.tel)"
                    @paste="isPaste($event)"
                    placeholder="x"
                    single-line
                    outlined
                    dense
                  ></v-otp-input>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <label class="label_form_text">เลขที่เสียภาษี</label>
                  <v-otp-input
                    length="13"
                    type="text"
                    color="#D6BFAF"
                    v-model="customer_register.tax_number"
                    @keypress="
                      isTaxNumber($event, customer_register.tax_number)
                    "
                    hide-details="auto"
                    @paste="isPaste($event)"
                    placeholder="x"
                    single-line
                    outlined
                    dense
                  >
                  </v-otp-input>
                </v-col>
                <v-col cols="12">
                  <div class="text_title mt-2">เลขที่สาขา</div>
                  <div class="mt-2">
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-account"
                      hide-details="auto"
                      v-model="customer_register.branch_number"
                      placeholder="กรุณากรอกเลขที่สาขา"
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ที่อยู่</label>
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-home"
                      hide-details="auto"
                      v-model="customer_register.address"
                      placeholder="กรุณากรอกที่อยู่"
                      single-line
                      outlined
                      maxLength="255"
                      dense
                    ></v-text-field>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <v-autocomplete
                      color="#D6BFAF"
                      class="input-radius"
                      hide-details="auto"
                      :items="addressList"
                      item-text="name"
                      item-value="name"
                      v-model="customer_register.province_data"
                      placeholder="กรุณากรอกตำบล,อำเภอ,จังหวัด,รหัสไปรษณีย์"
                      single-line
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">โน๊ต</label>
                    <v-textarea
                      class="input-radius"
                      v-model="customer_register.note"
                      solo
                      single-line
                      outlined
                      maxLength="1000"
                      dense
                    ></v-textarea>
                  </v-form-group>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn type="submit" class="btn_add_data_pop" elevation="4" large
                >บันทึก</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- สิ้นสุดสมัครสมาชิก -->
      <!-- รับเงิน -->
      <v-dialog v-model="dialog_cash" persistent max-width="960">
        <v-form ref="payment" @submit.prevent="updateData()">
          <v-card class="input-radius">
            <div class="d-flex justify-space-between">
              <v-card-title>
                <b>การชำระเงิน</b>
              </v-card-title>
              <v-btn
                icon
                class="ma-4"
                @click="(dialog_cash = false), calculate_last()"
              >
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="4" md="4" lg="4" xl="4" cols="12">
                  <div class="d-flex align-center">
                    <v-icon class="mr-2">mdi-account-circle</v-icon>
                    <b style="font-size: 16px">{{
                      payment_data.customer_name == null
                        ? "-"
                        : payment_data.customer_name
                    }}</b>
                  </div>
                </v-col>
                <v-col xs="12" sm="4" md="4" lg="4" xl="4" cols="12">
                  <div class="d-flex align-center">
                    <v-icon class="mr-2">mdi-phone</v-icon>
                    <b style="font-size: 16px">{{
                      payment_data.customer_tel == null
                        ? "-"
                        : payment_data.customer_tel
                    }}</b>
                  </div>
                </v-col>
                <v-col xs="12" sm="4" md="4" lg="4" xl="4" cols="12">
                  <div class="d-flex align-center">
                    <v-icon class="mr-2">mdi-star-circle</v-icon>
                    <b style="font-size: 16px"
                      >{{
                        payment_data.customer_point
                        ? formatPrice(payment_data.customer_point)
                        : 0
                      }}
                      แต้ม</b
                    >
                  </div>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text>
              <v-divider></v-divider>
              <v-row>
                <v-col xs="12" sm="8" md="8" lg="8" xl="8" cols="12">
                  <div class="d-flex">
                    <v-card
                      v-for="item in card_data"
                      :key="item.id"
                      style="
                        border-radius: 10px;
                        width: 100px;
                        height: 85px;
                        margin: 10px;
                      "
                      @click="tab_cash(item.id), sendMessage()"
                    >
                      <v-card-text>
                        <center>
                          <v-icon
                            :class="
                              chk_id.find((o) => o === item.id)
                                ? 'active-tab-cash-text mb-1'
                                : 'mb-1'
                            "
                            width="25"
                            height="25"
                            >{{ item.icon }}</v-icon
                          >
                          <h4
                            :class="
                              chk_id.find((o) => o === item.id)
                                ? 'active-tab-cash-text'
                                : ''
                            "
                          >
                            {{ item.type }}
                          </h4>
                        </center>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
                <v-col xs="12" sm="4" md="4" lg="4" xl="4" cols="12">
                  <v-text-field
                    v-if="payment_data.customer_name != null"
                    class="input-radius"
                    style="margin: 10px"
                    hide-details="auto"
                    type="number"
                    prepend-inner-icon="mdi-star-circle"
                    color="#D6BFAF"
                    v-model="payment_data.use_point"
                    @input="checkPoint()"
                    placeholder="จำนวนแต้มที่ต้องการใช้"
                    single-line
                    solo
                    outlined
                    dense
                  >
                  </v-text-field>
                  <v-text-field
                    v-else
                    class="input-radius"
                    style="margin: 10px"
                    hide-details="auto"
                    type="number"
                    prepend-inner-icon="mdi-star-circle"
                    color="#D6BFAF"
                    v-model="payment_data.use_point"
                    placeholder="จำนวนแต้มที่ต้องการใช้"
                    single-line
                    solo
                    outlined
                    dense
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <v-form-group>
                                    <label v-if="cash_type == 5" class="label_form_text">ประเภทบัตรเครดิต <span
                                            class="required--text">*</span></label>
                                    <v-autocomplete v-if="cash_type == 5" class="input-radius"
                                        placeholder="กรุณาเลือกประเภทบัตรเครดิต" single-line solo outlined dense>
                                    </v-autocomplete>
                                    <label v-if="cash_type == 4" class="label_form_text">จำนวนเงินที่ชำระอื่นๆ <span
                                            class="required--text">*</span></label>
                                    <v-autocomplete v-if="cash_type == 4" class="input-radius"
                                        placeholder="กรุณาเลือกประเภทการชำระเงิน" single-line solo outlined dense>
                                    </v-autocomplete>
                                </v-form-group>

                                </v-col> -->
                <v-col cols="8" xs="8" sm="8" md="8" lg="8" xl="8">
                  <v-row>
                    <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                      <v-card
                        v-if="chk_id.length == 1"
                        style="border: 1px solid #d6bfaf; border-radius: 10px"
                      >
                        <v-card-text>
                          <v-row>
                            <v-col
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              xl="12"
                              cols="12"
                            >
                              <v-form-group>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    v-for="item in chk_id"
                                    :key="item.id"
                                  >
                                    <v-row>
                                      <v-col cols="2">
                                        <v-img
                                          v-if="item == 1"
                                          src="@/assets/arin_assets/money_pos.png"
                                          width="64"
                                          height="64"
                                        ></v-img>
                                        <v-img
                                          v-if="item == 2"
                                          src="@/assets/arin_assets/paymeny_pos.png"
                                          width="64"
                                          height="64"
                                        ></v-img>
                                        <v-img
                                          v-if="item == 5"
                                          src="@/assets/arin_assets/qrcode_pos.png"
                                          width="64"
                                          height="64"
                                        ></v-img>
                                        <v-img
                                          v-if="item == 3"
                                          src="@/assets/arin_assets/credit_pos.png"
                                          width="64"
                                          height="64"
                                        ></v-img>
                                        <v-img
                                          v-if="item == 4"
                                          src="@/assets/arin_assets/another_pos.png"
                                          width="64"
                                          height="64"
                                        ></v-img>
                                      </v-col>
                                      <v-col cols="10">
                                        <label
                                          v-if="item == 1"
                                          class="label_form_text"
                                          >จำนวนเงินที่ชำระเป็นเงินสด
                                          <span class="required--text"
                                            >*</span
                                          ></label
                                        >
                                        <label
                                          v-if="item == 2"
                                          class="label_form_text"
                                          >จำนวนเงินที่ชำระเป็นเงินโอน
                                          <span class="required--text"
                                            >*</span
                                          ></label
                                        >
                                        <label
                                          v-if="item == 5"
                                          class="label_form_text"
                                          >จำนวนเงินที่ชำระผ่าน Qr Code
                                          <span class="required--text"
                                            >*</span
                                          ></label
                                        >
                                        <label
                                          v-if="item == 3"
                                          class="label_form_text"
                                          >ประเภทบัตรเครดิต
                                          <v-select
                                            class="required--text"
                                            color="#D6BFAF"
                                            :items="credit_type_list"
                                            item-text="card_name_eng"
                                            item-value="id"
                                            v-model="credit_id"
                                            single-line
                                            dense
                                            outlined
                                          ></v-select
                                        ></label>
                                        <label
                                          v-if="item == 3"
                                          class="label_form_text"
                                          >จำนวนเงินที่ชำระผ่านบัตรเครดิต
                                          <span class="required--text"
                                            >*</span
                                          ></label
                                        >
                                        <label
                                          v-if="item == 4"
                                          class="label_form_text"
                                          >หมายเหตุ
                                          <v-text-field
                                            v-if="item == 4"
                                            color="#D6BFAF"
                                            class="input-radius mb-4"
                                            type="text"
                                            hide-details="auto"
                                            v-model="payment_data.pay_note"
                                            placeholder="กรุณากรอกหมายเหตุ"
                                            outlined
                                          >
                                          </v-text-field
                                        ></label>
                                        <label
                                          v-if="item == 4"
                                          class="label_form_text"
                                          >จำนวนเงินที่ชำระอื่นๆ
                                          <span class="required--text"
                                            >*</span
                                          ></label
                                        >
                                        <v-text-field
                                          v-if="item == 1"
                                          @input="sendMessage()"
                                          color="#D6BFAF"
                                          class="input-radius"
                                          prepend-inner-icon="mdi-bitcoin"
                                          type="number"
                                          @keypress="
                                            isCurrency(
                                              $event,
                                              payment_data.payment_cash
                                            )
                                          "
                                          @paste="isPaste($event)"
                                          hide-details="auto"
                                          v-model="payment_data.payment_cash"
                                          :rules="[
                                            (v) =>
                                              !!v ||
                                              'กรุณากรอกจำนวนเงินที่ชำระเป็นเงินสด',
                                          ]"
                                          placeholder="กรุณากรอกจำนวนเงินที่ชำระเป็นเงินสด"
                                          maxlength="7"
                                          single-line
                                          outlined
                                          dense
                                          required
                                        >
                                        </v-text-field>
                                        <v-text-field
                                          v-if="item == 2"
                                          @input="sendMessage()"
                                          color="#D6BFAF"
                                          class="input-radius"
                                          prepend-inner-icon="mdi-bitcoin"
                                          type="number"
                                          @keypress="
                                            isCurrency(
                                              $event,
                                              payment_data.payment_pay
                                            )
                                          "
                                          @paste="isPaste($event)"
                                          hide-details="auto"
                                          v-model="payment_data.payment_pay"
                                          :rules="[
                                            (v) =>
                                              !!v ||
                                              'กรุณากรอกจำนวนเงินที่ชำระเงินโอน',
                                          ]"
                                          placeholder="กรุณากรอกจำนวนเงินที่ชำระเงินโอน"
                                          maxlength="7"
                                          single-line
                                          outlined
                                          dense
                                          required
                                        >
                                        </v-text-field>
                                        <v-text-field
                                          v-if="item == 5"
                                          @input="sendMessage()"
                                          color="#D6BFAF"
                                          class="input-radius"
                                          prepend-inner-icon="mdi-bitcoin"
                                          type="number"
                                          @keypress="
                                            isCurrency(
                                              $event,
                                              payment_data.payment_qrcode
                                            )
                                          "
                                          @paste="isPaste($event)"
                                          hide-details="auto"
                                          v-model="payment_data.payment_qrcode"
                                          :rules="[
                                            (v) =>
                                              !!v ||
                                              'กรุณากรอกจำนวนเงินที่ชำระ Qr Code',
                                          ]"
                                          placeholder="กรุณากรอกจำนวนเงินที่ชำระ Qr Code"
                                          maxlength="7"
                                          single-line
                                          outlined
                                          dense
                                          required
                                        >
                                        </v-text-field>
                                        <v-text-field
                                          v-if="item == 3"
                                          @input="sendMessage()"
                                          color="#D6BFAF"
                                          class="input-radius"
                                          prepend-inner-icon="mdi-bitcoin"
                                          type="number"
                                          @keypress="
                                            isCurrency(
                                              $event,
                                              payment_data.payment_credit
                                            )
                                          "
                                          @paste="isPaste($event)"
                                          hide-details="auto"
                                          v-model="payment_data.payment_credit"
                                          :rules="[
                                            (v) =>
                                              !!v ||
                                              'กรุณากรอกจำนวนเงินที่ชำระบัตรเครดิต',
                                          ]"
                                          placeholder="กรุณากรอกจำนวนเงินที่ชำระบัตรเครดิต"
                                          maxlength="7"
                                          single-line
                                          outlined
                                          dense
                                          required
                                        >
                                        </v-text-field>
                                        <v-text-field
                                          v-if="item == 4"
                                          @input="sendMessage()"
                                          color="#D6BFAF"
                                          class="input-radius"
                                          prepend-inner-icon="mdi-bitcoin"
                                          type="number"
                                          @keypress="
                                            isCurrency(
                                              $event,
                                              payment_data.payment_other
                                            )
                                          "
                                          @paste="isPaste($event)"
                                          hide-details="auto"
                                          v-model="payment_data.payment_other"
                                          :rules="[
                                            (v) =>
                                              !!v ||
                                              'กรุณากรอกจำนวนเงินที่ชำระอื่นๆ',
                                          ]"
                                          placeholder="กรุณากรอกจำนวนเงินที่ชำระอื่นๆ"
                                          maxlength="7"
                                          single-line
                                          outlined
                                          dense
                                          required
                                        >
                                        </v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-form-group>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <v-col cols="12" v-else>
                        <v-row>
                          <v-col cols="6" v-for="item in chk_id" :key="item.id">
                            <v-card
                              style="
                                border: 1px solid #d6bfaf;
                                border-radius: 10px;
                              "
                            >
                              <v-card-text>
                                <v-row>
                                  <v-col
                                    xs="12"
                                    sm="12"
                                    md="10"
                                    lg="10"
                                    xl="10"
                                    cols="12"
                                  >
                                    <v-form-group>
                                      <v-row>
                                        <v-col cols="12">
                                          <v-row>
                                            <v-col cols="12">
                                              <v-row>
                                                <v-col cols="4">
                                                  <v-img
                                                    v-if="item == 1"
                                                    src="@/assets/arin_assets/money_pos.png"
                                                    width="64"
                                                    height="64"
                                                  ></v-img>
                                                  <v-img
                                                    v-if="item == 2"
                                                    src="@/assets/arin_assets/paymeny_pos.png"
                                                    width="64"
                                                    height="64"
                                                  ></v-img>
                                                  <v-img
                                                    v-if="item == 5"
                                                    src="@/assets/arin_assets/qrcode_pos.png"
                                                    width="64"
                                                    height="64"
                                                  ></v-img>
                                                  <v-img
                                                    v-if="item == 3"
                                                    src="@/assets/arin_assets/credit_pos.png"
                                                    width="64"
                                                    height="64"
                                                  ></v-img>
                                                  <v-img
                                                    v-if="item == 4"
                                                    src="@/assets/arin_assets/another_pos.png"
                                                    width="64"
                                                    height="64"
                                                  ></v-img>
                                                </v-col>
                                                <v-col cols="8">
                                                  <label
                                                    v-if="item == 1"
                                                    class="label_form_text"
                                                    >จำนวนเงินที่ชำระเป็นเงินสด
                                                    <span class="required--text"
                                                      >*</span
                                                    ></label
                                                  >
                                                  <label
                                                    v-if="item == 2"
                                                    class="label_form_text"
                                                    >จำนวนเงินที่ชำระเป็นเงินโอน
                                                    <span class="required--text"
                                                      >*</span
                                                    ></label
                                                  >
                                                  <label
                                                    v-if="item == 5"
                                                    class="label_form_text"
                                                    >จำนวนเงินที่ชำระผ่าน Qr
                                                    Code
                                                    <span class="required--text"
                                                      >*</span
                                                    ></label
                                                  >
                                                  <label
                                                    v-if="item == 3"
                                                    class="label_form_text"
                                                    >ประเภทบัตรเครดิต
                                                    <v-select
                                                      class="required--text"
                                                      :items="credit_type_list"
                                                      item-text="card_name_eng"
                                                      item-value="id"
                                                      v-model="credit_id"
                                                      outlined
                                                    ></v-select
                                                  ></label>
                                                  <label
                                                    v-if="item == 3"
                                                    class="label_form_text"
                                                    >จำนวนเงินที่ชำระผ่านบัตรเครดิต
                                                    <span class="required--text"
                                                      >*</span
                                                    ></label
                                                  >
                                                  <label
                                                    v-if="item == 4"
                                                    class="label_form_text"
                                                    >หมายเหตุ
                                                    <v-text-field
                                                      v-if="item == 4"
                                                      color="#D6BFAF"
                                                      class="input-radius mb-4"
                                                      type="text"
                                                      hide-details="auto"
                                                      v-model="
                                                        payment_data.pay_note
                                                      "
                                                      placeholder="กรุณากรอกหมายเหตุ"
                                                      outlined
                                                    >
                                                    </v-text-field
                                                  ></label>
                                                  <label
                                                    v-if="item == 4"
                                                    class="label_form_text"
                                                    >จำนวนเงินที่ชำระอื่นๆ
                                                    <span class="required--text"
                                                      >*</span
                                                    ></label
                                                  >
                                                  <v-text-field
                                                    @input="sendMessage()"
                                                    v-if="item == 1"
                                                    color="#D6BFAF"
                                                    class="input-radius"
                                                    prepend-inner-icon="mdi-bitcoin"
                                                    @keypress="
                                                      isCurrency(
                                                        $event,
                                                        payment_data.payment_cash
                                                      )
                                                    "
                                                    @paste="isPaste($event)"
                                                    hide-details="auto"
                                                    v-model="
                                                      payment_data.payment_cash
                                                    "
                                                    :rules="[
                                                      (v) =>
                                                        !!v ||
                                                        'กรุณากรอกจำนวนเงินที่ชำระเป็นเงินสด',
                                                    ]"
                                                    placeholder="กรุณากรอกจำนวนเงินที่ชำระเป็นเงินสด"
                                                    maxlength="7"
                                                    single-line
                                                    outlined
                                                    dense
                                                    required
                                                  >
                                                  </v-text-field>
                                                  <v-text-field
                                                    @input="sendMessage()"
                                                    v-if="item == 2"
                                                    color="#D6BFAF"
                                                    class="input-radius"
                                                    prepend-inner-icon="mdi-bitcoin"
                                                    @keypress="
                                                      isCurrency(
                                                        $event,
                                                        payment_data.payment_pay
                                                      )
                                                    "
                                                    @paste="isPaste($event)"
                                                    hide-details="auto"
                                                    v-model="
                                                      payment_data.payment_pay
                                                    "
                                                    :rules="[
                                                      (v) =>
                                                        !!v ||
                                                        'กรุณากรอกจำนวนเงินที่ชำระเงินโอน',
                                                    ]"
                                                    placeholder="กรุณากรอกจำนวนเงินที่ชำระเงินโอน"
                                                    maxlength="7"
                                                    single-line
                                                    outlined
                                                    dense
                                                    required
                                                  >
                                                  </v-text-field>
                                                  <v-text-field
                                                    @input="sendMessage()"
                                                    v-if="item == 5"
                                                    color="#D6BFAF"
                                                    class="input-radius"
                                                    prepend-inner-icon="mdi-bitcoin"
                                                    @keypress="
                                                      isCurrency(
                                                        $event,
                                                        payment_data.payment_qrcode
                                                      )
                                                    "
                                                    @paste="isPaste($event)"
                                                    hide-details="auto"
                                                    v-model="
                                                      payment_data.payment_qrcode
                                                    "
                                                    :rules="[
                                                      (v) =>
                                                        !!v ||
                                                        'กรุณากรอกจำนวนเงินที่ชำระ Qr Code',
                                                    ]"
                                                    placeholder="กรุณากรอกจำนวนเงินที่ชำระ Qr Code"
                                                    maxlength="7"
                                                    single-line
                                                    outlined
                                                    dense
                                                    required
                                                  >
                                                  </v-text-field>
                                                  <v-text-field
                                                    @input="sendMessage()"
                                                    v-if="item == 3"
                                                    color="#D6BFAF"
                                                    class="input-radius"
                                                    prepend-inner-icon="mdi-bitcoin"
                                                    @keypress="
                                                      isCurrency(
                                                        $event,
                                                        payment_data.payment_credit
                                                      )
                                                    "
                                                    @paste="isPaste($event)"
                                                    hide-details="auto"
                                                    v-model="
                                                      payment_data.payment_credit
                                                    "
                                                    :rules="[
                                                      (v) =>
                                                        !!v ||
                                                        'กรุณากรอกจำนวนเงินที่ชำระบัตรเครดิต',
                                                    ]"
                                                    placeholder="กรุณากรอกจำนวนเงินที่ชำระบัตรเครดิต"
                                                    maxlength="7"
                                                    single-line
                                                    outlined
                                                    dense
                                                    required
                                                  >
                                                  </v-text-field>
                                                  <v-text-field
                                                    @input="sendMessage()"
                                                    v-if="item == 4"
                                                    color="#D6BFAF"
                                                    class="input-radius"
                                                    prepend-inner-icon="mdi-bitcoin"
                                                    @keypress="
                                                      isCurrency(
                                                        $event,
                                                        payment_data.payment_other
                                                      )
                                                    "
                                                    @paste="isPaste($event)"
                                                    hide-details="auto"
                                                    v-model="
                                                      payment_data.payment_other
                                                    "
                                                    :rules="[
                                                      (v) =>
                                                        !!v ||
                                                        'กรุณากรอกจำนวนเงินที่ชำระอื่นๆ',
                                                    ]"
                                                    placeholder="กรุณากรอกจำนวนเงินที่ชำระอื่นๆ"
                                                    maxlength="7"
                                                    single-line
                                                    outlined
                                                    dense
                                                    required
                                                  >
                                                  </v-text-field>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                        </v-col>
                                      </v-row>
                                    </v-form-group>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                  <v-row v-if="chk_id.length > 0" class="mt-2">
                    <v-col cols="12">
                      <label class="label_form_text">หมายเหตุ</label>
                      <v-textarea
                        v-model="payment_data.reason"
                        class="input-radius"
                        color="#D6BFAF"
                        hide-details="auto"
                        auto-grow
                        rows="2"
                        placeholder="หมายเหตุเพิ่มเติม (ถ้ามี)"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
                  <v-row>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      cols="12"
                      class="pb-0"
                    >
                      <v-radio-group v-model="vat_selection">
                        <div
                          class="d-flex"
                          style="justify-content: space-between"
                        >
                          <v-radio
                            v-if="vat_defualt != 2"
                            :label="
                              vat_defualt == 0 ? 'ภาษีรวมใน' : 'ภาษีแยกนอก'
                            "
                            :value="vat_defualt == 0 ? 0 : 1"
                          ></v-radio>
                          <v-radio label="ไม่คิดภาษี" value="2"></v-radio>
                        </div>
                      </v-radio-group>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      cols="12"
                      class="pb-0"
                    >
                      <div
                        class="d-flex"
                        style="justify-content: space-between"
                      >
                        <p style="font-size: 16px" class="mb-0">
                          รวมส่วนลดสินค้า
                        </p>
                        <p style="font-size: 16px" class="mb-0">
                          {{ formatPrice(discount) }}
                        </p>
                      </div>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      cols="12"
                      class="pb-0"
                    >
                      <div
                        class="d-flex"
                        style="justify-content: space-between"
                      >
                        <p style="font-size: 16px" class="mb-0">
                          ส่วนลดโปรโมชั่น
                        </p>
                        <p style="font-size: 16px" class="mb-0">
                          {{ formatPrice(promotion_discount) }}
                        </p>
                      </div>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      cols="12"
                      class="py-0"
                    >
                      <div
                        class="d-flex"
                        style="justify-content: space-between"
                      >
                        <p
                          style="font-size: 16px; padding-top: 15px"
                          class="mb-0"
                        >
                          ส่วนลดท้ายบิล
                        </p>
                        <v-col cols="4" class="pr-0">
                          <p style="font-size: 16px" class="mb-0">
                            <v-text-field
                              color="#D6BFAF"
                              class="input-radius"
                              hide-details="auto"
                              type="number"
                              v-model="discount_last"
                              maxlength="5"
                              @input="calculate_last(), sendMessage()"
                              @keypress="isCurrency($event, discount_last)"
                              @paste="isPaste($event)"
                              placeholder="ส่วนลดท้ายบิล"
                              single-line
                              outlined
                              dense
                              required
                            ></v-text-field>
                          </p>
                        </v-col>
                      </div>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      cols="12"
                      class="py-0"
                    >
                      <div
                        class="d-flex"
                        style="justify-content: space-between"
                      >
                        <p style="font-size: 16px">มูลค่าสินค้า</p>
                        <p v-if="vat_type == 0" style="font-size: 16px">
                          {{
                            formatPrice(
                              parseFloat(
                                summary -
                                  discount -
                                  promotion_discount -
                                  discount_last
                              ) *
                                (100 / 107)
                            )
                          }}
                        </p>
                        <p v-if="vat_type == 1" style="font-size: 16px">
                          {{
                            formatPrice(
                              parseFloat(
                                summary -
                                  discount -
                                  promotion_discount -
                                  discount_last
                              )
                            )
                          }}
                        </p>
                        <p v-if="vat_type == 2" style="font-size: 16px">
                          {{
                            formatPrice(
                              parseFloat(
                                summary -
                                  discount -
                                  promotion_discount -
                                  discount_last
                              )
                            )
                          }}
                        </p>
                      </div>
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      cols="12"
                      class="py-0"
                    >
                      <div
                        class="d-flex"
                        style="justify-content: space-between"
                      >
                        <p style="font-size: 16px">ภาษี 7%</p>
                        <p style="font-size: 16px">
                          {{
                            vat_type == 0
                              ? formatPrice(
                                  summary -
                                    discount -
                                    promotion_discount -
                                    discount_last -
                                    (summary -
                                      discount -
                                      promotion_discount -
                                      discount_last) *
                                      (100 / 107)
                                )
                              : vat_type == 1
                              ? formatPrice(
                                  ((summary -
                                    discount -
                                    promotion_discount -
                                    discount_last) *
                                    7) /
                                    100
                                )
                              : 0
                          }}
                        </p>
                      </div>
                    </v-col>
                    <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                      <p
                        v-if="chk_id.find((o) => o === 3) && credit_status == 1"
                        style="color: #b0886b; text-align: right"
                      >
                        เครดิตชาร์จ {{ parseInt(credit_charge * 100) }}% :
                        {{
                          formatPrice(
                            parseFloat(
                              payment_data.payment_credit == null ||
                                payment_data.payment_credit == ""
                                ? 0
                                : payment_data.payment_credit
                            ) * credit_charge
                          )
                        }}
                      </p>
                      <h2
                        v-if="chk_id.find((o) => o === 3)"
                        style="color: #b0886b; text-align: right"
                      >
                        ราคารวมสุทธิ
                        {{
                          formatPrice(
                             parseFloat(net) +
                                  parseFloat(
                                    payment_data.payment_credit == null ||
                                      payment_data.payment_credit == ""
                                      ? 0
                                      : payment_data.payment_credit
                                  ) *
                                    credit_charge -
                                  parseFloat(
                                    (payment_data.use_point =
                                      null || payment_data.use_point == ""
                                        ? 0
                                        : payment_data.use_point)
                                  )
                             
                          )
                        }}
                      </h2>
                      <h2
                        v-if="!chk_id.find((o) => o === 3)"
                        style="color: #b0886b; text-align: right"
                      >
                        ราคารวมสุทธิ
                        {{
                          formatPrice(
                            net -
                              parseFloat(
                                (payment_data.use_point =
                                  null || payment_data.use_point == ""
                                    ? 0
                                    : payment_data.use_point)
                              )
                          )
                        }}
                      </h2>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <h2 style="color: #616a6b; text-align: right">
                    รับเงิน
                    {{
                      formatPrice(
                        parseFloat(
                          payment_data.payment_cash == "" ||
                            payment_data.payment_cash == null
                            ? 0
                            : payment_data.payment_cash
                        ) +
                          parseFloat(
                            payment_data.payment_pay == "" ||
                              payment_data.payment_pay == null
                              ? 0
                              : payment_data.payment_pay
                          ) +
                          parseFloat(
                            payment_data.payment_credit == "" ||
                              payment_data.payment_credit == null
                              ? 0
                              : payment_data.payment_credit
                          ) +
                          parseFloat(
                            payment_data.payment_other == "" ||
                              payment_data.payment_other == null
                              ? 0
                              : payment_data.payment_other
                          ) +
                          parseFloat(
                            payment_data.payment_qrcode == "" ||
                              payment_data.payment_qrcode == null
                              ? 0
                              : payment_data.payment_qrcode
                          )
                      )
                    }}
                  </h2>
                  <h2
                    v-if="
                      parseFloat(
                        payment_data.payment_cash == '' ||
                          payment_data.payment_cash == null
                          ? 0
                          : payment_data.payment_cash
                      ) +
                        parseFloat(
                          payment_data.payment_pay == '' ||
                            payment_data.payment_pay == null
                            ? 0
                            : payment_data.payment_pay
                        ) +
                        parseFloat(
                          payment_data.payment_credit == '' ||
                            payment_data.payment_credit == null
                            ? 0
                            : payment_data.payment_credit
                        ) +
                        parseFloat(
                          payment_data.payment_other == '' ||
                            payment_data.payment_other == null
                            ? 0
                            : payment_data.payment_other
                        ) +
                        parseFloat(
                          payment_data.payment_qrcode == '' ||
                            payment_data.payment_qrcode == null
                            ? 0
                            : payment_data.payment_qrcode
                        ) -
                        (parseFloat(net) - parseFloat(payment_data.use_point)) <
                        0 && !chk_id.find((o) => o === 3)
                    "
                    class="mt-2"
                    style="color: #616a6b; text-align: right"
                  >
                    เงินทอน {{ 0 }}
                  </h2>
                  <h2
                    v-else-if="
                      parseFloat(
                        payment_data.payment_cash == '' ||
                          payment_data.payment_cash == null
                          ? 0
                          : payment_data.payment_cash
                      ) +
                        parseFloat(
                          payment_data.payment_pay == '' ||
                            payment_data.payment_pay == null
                            ? 0
                            : payment_data.payment_pay
                        ) +
                        parseFloat(
                          payment_data.payment_credit == '' ||
                            payment_data.payment_credit == null
                            ? 0
                            : payment_data.payment_credit
                        ) +
                        parseFloat(
                          payment_data.payment_other == '' ||
                            payment_data.payment_other == null
                            ? 0
                            : payment_data.payment_other
                        ) +
                        parseFloat(
                          payment_data.payment_qrcode == '' ||
                            payment_data.payment_qrcode == null
                            ? 0
                            : payment_data.payment_qrcode
                        ) -
                        (parseFloat(net) - parseFloat(payment_data.use_point)) -
                        parseFloat(net) *
                          parseFloat(credit_status == 1 ? credit_charge : 0) <
                        0 && chk_id.find((o) => o === 3)
                    "
                    class="mt-2"
                    style="color: #616a6b; text-align: right"
                  >
                    เงินทอน {{ 0 }}
                  </h2>
                  <h2
                    v-else-if="chk_id.find((o) => o === 3)"
                    class="mt-2"
                    style="color: #616a6b; text-align: right"
                  >
                    เงินทอน
                    {{
                      formatPrice(
                        parseFloat(
                          payment_data.payment_cash == "" ||
                            payment_data.payment_cash == null
                            ? 0
                            : payment_data.payment_cash
                        ) +
                          parseFloat(
                            payment_data.payment_pay == "" ||
                              payment_data.payment_pay == null
                              ? 0
                              : payment_data.payment_pay
                          ) +
                          parseFloat(
                            payment_data.payment_credit == "" ||
                              payment_data.payment_credit == null
                              ? 0
                              : payment_data.payment_credit
                          ) +
                          parseFloat(
                            payment_data.payment_other == "" ||
                              payment_data.payment_other == null
                              ? 0
                              : payment_data.payment_other
                          ) +
                          parseFloat(
                            payment_data.payment_qrcode == "" ||
                              payment_data.payment_qrcode == null
                              ? 0
                              : payment_data.payment_qrcode
                          ) -
                          (parseFloat(net) -
                            parseFloat(payment_data.use_point) +
                            parseFloat(net) *
                              parseFloat(
                                credit_status == 1 ? credit_charge : 0
                              ))
                      )
                    }}
                  </h2>
                  <h2
                    v-else-if="!chk_id.find((o) => o === 3)"
                    class="mt-2"
                    style="color: #616a6b; text-align: right"
                  >
                    เงินทอน
                    {{
                      formatPrice(
                        parseFloat(
                          payment_data.payment_cash == "" ||
                            payment_data.payment_cash == null
                            ? 0
                            : payment_data.payment_cash
                        ) +
                          parseFloat(
                            payment_data.payment_pay == "" ||
                              payment_data.payment_pay == null
                              ? 0
                              : payment_data.payment_pay
                          ) +
                          parseFloat(
                            payment_data.payment_credit == "" ||
                              payment_data.payment_credit == null
                              ? 0
                              : payment_data.payment_credit
                          ) +
                          parseFloat(
                            payment_data.payment_other == "" ||
                              payment_data.payment_other == null
                              ? 0
                              : payment_data.payment_other
                          ) +
                          parseFloat(
                            payment_data.payment_qrcode == "" ||
                              payment_data.payment_qrcode == null
                              ? 0
                              : payment_data.payment_qrcode
                          ) -
                          (parseFloat(net) - parseFloat(payment_data.use_point))
                      )
                    }}
                  </h2>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                v-if="chk_id.length > 0"
                type="submit"
                class="btn_add_data_pop"
                elevation="4"
                large
                :disabled="loading_page"
                :loading="loading_page"
                >ชำระเงิน</v-btn
              >
              <v-btn
                v-else
                type="button"
                class="btn_add_data_pop"
                elevation="4"
                large
                disabled
                >ชำระเงิน</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- สิ้นสุดรับเงิน -->
      <!-- ชำระเงินสำเร็จ -->
      <v-dialog v-model="dialog_cash_success" persistent max-width="500">
        <v-card class="input-radius">
          <div class="d-flex justify-end">
            <v-btn
              icon
              class="ma-4"
              @click="
                (dialog_cash_success = false),
                  (print_receipt = false),
                  getInvoice();
                reset_all(), reloadPage();
              "
            >
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img
                    width="150"
                    height="150"
                    src="@/assets/arin_assets/payment_success_pos.png"
                    class="preview mt-3 mb-2"
                  ></v-img>
                </center>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                <p style="color: #88b358; font-size: 26px">
                  เงินถอน
                  {{
                    formatPrice(
                      (
                        parseFloat(payment_data.payment_cash || 0) +
                        parseFloat(payment_data.payment_pay || 0) +
                        parseFloat(payment_data.payment_credit || 0) +
                        parseFloat(payment_data.payment_other || 0) +
                        parseFloat(payment_data.payment_qrcode || 0)
                      ) -
                      (
                        parseFloat(net || 0) -
                        parseFloat(payment_data.use_point || 0) +
                        (chk_id.includes(3) && credit_status == 1
                          ? parseFloat(net || 0) * parseFloat(credit_charge || 0)
                          : 0)
                      )
                    )
                  }}
                  บาท
                </p>
                <p style="color: #88b358; font-size: 26px">เรียบร้อยแล้ว</p>
              </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-row>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="6"
                xl="6"
                cols="12"
                class="text-right"
              >
                <v-btn
                  style="border-radius: 10px; width: 100%"
                  type="button"
                  outlined
                  color="#8EBBDC"
                  @click="link('/arin/pos/posinvoicestaxadd/' + invoice_id)"
                  large
                  >ทำใบแจ้งหนี้/ใบกำกับภาษี</v-btn
                >
              </v-col>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="6"
                xl="6"
                cols="12"
                class="text-left"
              >
                <v-btn
                  style="border-radius: 10px; width: 100%"
                  type="button"
                  outlined
                  color="#FEA06C"
                  @click="
                    link('/arin/pos/posinvoicestaxrefundadd/' + invoice_id)
                  "
                  large
                  >ทำใบ Tax Refund</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- สิ้นสุดชำระเงินสำเร็จ -->
      <!-- Dialog เมนูข้าง -->
      <!-- เมนูสินค้า -->
      <v-dialog v-model="open_product" persistent max-width="1200">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>รายการสินค้า</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="open_product = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-title style="display: flex; justify-content: flex-end">
            <div>
              <v-text-field
                color="#D6BFAF"
                class="input-radius"
                append-icon="mdi-magnify"
                hide-details="auto"
                @input="pagetination(0, 10, search), (page = 1)"
                v-model="search"
                placeholder="ค้นหา..."
                single-line
                outlined
                dense
              ></v-text-field>
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                cols="12"
                class="my-2"
              >
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">รหัสสินค้า</th>
                        <th class="text-left">ชื่อสินค้า</th>
                        <th class="text-left">ชื่อทางการแพทย์</th>
                        <th class="text-left">ประเภท</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in productList_data"
                        :key="item.id"
                        @click="addItem(item.barcode)"
                      >
                        <td>{{ item.product_code }}</td>
                        <td>{{ item.name }} ({{ item.unit_name }})</td>
                        <td>{{ item.name_sci }}</td>
                        <td>{{ item.product_type_name }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <div
                  class="text-center"
                  @click="
                    pagetination(
                      parseFloat(page > 1 ? 10 * (page - 1) : 0),
                      parseFloat(10) * parseFloat(page),
                      search
                    )
                  "
                >
                  <v-pagination
                    color="#d0b19b"
                    v-model="page"
                    :total-visible="7"
                    :length="page_all"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- สิ้นสุดเมนูสินค้า -->
      <!-- เมนูเริ่มขายใหม่ -->
      <v-dialog v-model="restart_pos" persistent max-width="450">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ยืนยันการเริ่มขายใหม่</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="restart_pos = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img
                    width="90"
                    height="90"
                    src="@/assets/arin_assets/approve 1.png"
                    class="preview mt-3 mb-2"
                  ></v-img>
                  <h3>คุณต้องการเริ่มขายใหม่ใช่หรือไม่</h3>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              class="btn_add_data_pop"
              elevation="4"
              @click="reset_all()"
              large
              >ยืนยัน</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- สิ้นสุดเมนูเริ่มขายใหม่ -->
      <!-- เมนูเปิดลิ้นชัก -->
      <v-dialog v-model="open_drawer_menu" persistent max-width="450">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ยืนยันการเปิดลิ้นชัก</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="open_drawer_menu = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img
                    width="90"
                    height="90"
                    src="@/assets/arin_assets/drawer_pos2.png"
                    class="preview mt-3 mb-2"
                  ></v-img>
                  <h3>คุณต้องการการเปิดลิ้นชักใช่หรือไม่</h3>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <iframe ref="printFrame" style="display: none"></iframe>
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              class="btn_add_data_pop"
              elevation="4"
              @click="openCashDrawer(), (open_drawer_menu = false)"
              large
              >ยืนยัน</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- สิ้นสุดเมนูเปิดลิ้นชัก -->
      <!-- เมนูพักบิล -->
      <v-dialog v-model="stop_pos" persistent max-width="450">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ยืนยันการพักบิลนี้</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="stop_pos = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img
                    width="90"
                    height="90"
                    src="@/assets/arin_assets/stop_pos.png"
                    class="preview mt-3 mb-2"
                  ></v-img>
                  <h3>คุณต้องการพักบิลนี้ใช่หรือไม่</h3>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              class="btn_add_data_pop"
              elevation="4"
              @click="saveData(1)"
              large
              >ยืนยัน</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- สิ้นสุดเมนูพักบิล -->
      <!-- เมนูยกเลิกใบเสร็จ -->
      <v-dialog v-model="cancel_bill" persistent max-width="580">
        <v-form ref="cancelBill" @submit.prevent="saveCancelInvoice()">
          <v-card class="input-radius">
            <div class="d-flex justify-space-between">
              <v-card-title>
                <b>ยกเลิกใบเสร็จ</b>
              </v-card-title>
              <v-btn icon class="ma-4" @click="cancel_bill = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >เลขที่ใบเสร็จ/ใบกำกับภาษี
                      <span class="required--text">*</span></label
                    >
                    <v-autocomplete
                      class="input-radius"
                      hide-details="auto"
                      item-text="invoice_code"
                      item-value="id"
                      :items="invoiceList"
                      :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                      placeholder="กรุณาเลือกเลขที่ใบเสร็จ/ใบกำกับภาษี"
                      single-line
                      solo
                      outlined
                      v-model="cancel.invoice_id"
                      dense
                      required
                    ></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text"
                      >สาเหตุการยกเลิกใบเสร็จ
                      <span class="required--text">*</span></label
                    >
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-alert"
                      hide-details="auto"
                      :rules="[(v) => !!v || 'กรุณากรอกสาเหตุการยกเลิกใบเสร็จ']"
                      maxlength="255"
                      v-model="cancel.note"
                      placeholder="กรุณากรอกสาเหตุการยกเลิกใบเสร็จ"
                      single-line
                      outlined
                      dense
                      required
                    >
                    </v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <label class="label_form_text"
                    >เบอร์โทรเข้าสู่ระบบ
                    <span class="required--text">*</span></label
                  >
                  <v-text-field
                    class="input-radius input-center"
                    type="text"
                    v-model="cancel.tel"
                    placeholder="กรุณากรอกเบอร์โทรเข้าสู่ระบบ"
                    color="#D6BFAF"
                    :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                    prepend-inner-icon="mdi-account"
                    @keypress="isNumber($event, telephone)"
                    @paste="isPaste($event)"
                    hide-details="auto"
                    single-line
                    solo
                    outlined
                    dense
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <label>รหัสผ่าน <span class="required--text">*</span></label>
                  <v-text-field
                    label="รหัสผ่าน"
                    prepend-inner-icon="mdi-lock"
                    v-model="cancel.password"
                    color="#D6BFAF"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    @click:append="show = !show"
                    single-line
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn type="submit" class="btn_add_data_pop" elevation="4" large
                >ยกเลิกบิล</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- สิ้นสุดเมนูยกเลิกใบเสร็จ -->
      <!-- เมนูล้างบิล -->
      <v-dialog v-model="clear_bill" persistent max-width="450">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ยืนยันการล้างใบเสร็จ</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="clear_bill = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img
                    width="90"
                    height="90"
                    src="@/assets/arin_assets/clear_bill.png"
                    class="preview mt-3 mb-2"
                  ></v-img>
                  <h3>คุณต้องการล้างใบเสร็จที่พักไว้ทั้งหมดใช่หรือไม่</h3>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              class="btn_add_data_pop"
              elevation="4"
              @click="removeBill_all()"
              large
              >ยืนยัน</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- สิ้นสุดเมนูล้างบิล -->
      <!-- สิ้นสุด Dialog เมนูข้าง -->

      <v-dialog v-model="in_stock" persistent max-width="450"  @keydown.enter="getFocusScaner()">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title> </v-card-title>
            <v-btn
              icon
              class="ma-4"
              @click="
                removeProduct(product_data.length - 1),
                  getFocusScaner(),
                  (in_stock = false)
              "
            >
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img
                    width="90"
                    height="90"
                    src="@/assets/arin_assets/warning.png"
                    class="preview mt-3 mb-2"
                  ></v-img>
                  <h2 style="font-size: 16px">
                    สินค้าหมดคลัง <br />คุณต้องการขายสินค้าต่อหรือไม่ ?
                  </h2>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              class="btn_add_data_pop"
              elevation="4"
              @click="getFocusScaner()"
              large
              >ตกลง</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Modal แจ้งเตือนไม่พบรายการ -->
      <v-dialog v-model="not_found" persistent max-width="450" @keydown.enter="getFocusScaner()">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>ไม่พบสินค้า</v-card-title>
            <v-btn icon class="ma-4" @click="not_found = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <center>
                  <v-img
                    width="90"
                    height="90"
                    src="@/assets/arin_assets/not_found.png"
                    class="preview mt-3 mb-2"
                  ></v-img>
                  <h2 style="font-size: 16px">
                    ไม่พบสินค้าที่ท่านค้นหาในระบบ
                    กรุณาลองอีกครั้งโดยใช้การสะกดแบบอื่นหรือเปลี่ยนคำค้นหา
                  </h2>
                </center>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <!-- <v-btn type="button" class="btn_add_data_pop_danger" style="
                background: linear-gradient(
                    90deg,
                    #ffff 0%,
                    rgba(136, 179, 88, 0) 100%
                  ),
                  #ffff !important;
              " color="error" elevation="4" outlined @click="getFocusScaner(), (not_found = false)" large>ยกเลิก</v-btn> -->
            <v-btn
              type="button"
              class="btn_add_data_pop"
              elevation="4"
              @click="getFocusScaner()"
              large
              >ตกลง</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Modal การแจ้งเตือนเสร็จสิ้น -->
      <v-dialog v-model="show_check_bill_success" persistent max-width="500px">
        <v-card class="input-radius pa-5">
          <v-card-title>
            <v-row>
              <v-col class="text-right py-0">
                <v-btn
                  icon
                  class="ma-1"
                  @click="
                    (show_check_bill_success = false), (print_receipt = false)
                  "
                >
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pb-10">
            <v-row>
              <v-col cols="12" class="title_page_center justify-center">
                <div class="">
                  <v-img width="178" class="w-100" :src="img_check"></v-img>
                </div>
              </v-col>
              <v-col cols="12 text-center">
                <h1 class="">ยกเลิกใบเสร็จสำเร็จ</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Modal การแจ้งเตือนเสร็จสิ้น -->
      <v-dialog
        v-model="show_check_clear_bill_success"
        persistent
        max-width="500px"
      >
        <v-card class="input-radius pa-5">
          <v-card-title>
            <v-row>
              <v-col class="text-right py-0">
                <v-btn
                  icon
                  class="ma-1"
                  @click="show_check_clear_bill_success = false"
                >
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pb-10">
            <v-row>
              <v-col cols="12" class="title_page_center justify-center">
                <div class="">
                  <v-img width="178" class="w-100" :src="img_check"></v-img>
                </div>
              </v-col>
              <v-col cols="12 text-center">
                <h1 class="">ล้างใบเสร็จที่พักไว้ทั้งหมดสำเร็จ</h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <div v-if="print_receipt" class="d-none">
      <iframe
        :src="
          '/arin/pos/posinvoicereceipt?id=' +
          (invoice_id ? invoice_id : cancel.invoice_id) +
          '&vat_status=' +
          vat_selection
        "
        title="print_receipt"
        @load="(dialog_cash = false), (dialog_cash_success = true)"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import {
  isTelephone,
  onPaste,
  onlyForCurrency,
  formatPrice,
  taxNumber,
} from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import img_check from "@/assets/arin_assets/check_success.png";
import io from "socket.io-client";
// import img_open_pos from "@/assets/arin_assets/schedule.png";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_page",
  data() {
    return {
      show: false,
      loading_page_global: true, // ใช้แสดง Skeleton Loader เฉพาะตอนโหลดครั้งแรก
      loading_page: false, // ใช้สำหรับการโหลดเฉพาะ function
      loading_page_counter: 0, // นับจำนวน API ที่โหลด
      isLoading: true,
      print_receipt: false,
      in_stock: false,
      img_check: img_check,
      alert_error: false,
      alert_message_error: null,
      alert_success: false,
      alert_message_success: null,
      show_check_bill_success: false,
      show_check_clear_bill_success: false,
      dialog_open_pos: false,
      open_customer: false,
      dialog_register: false,
      dialog_cash: false,
      dialog_cash_success: false,
      addressList: [],
      cash_type: [],
      chk_id: [],
      // เมนูข้าง
      open_product: false,
      restart_pos: false,
      open_drawer_menu: false,
      stop_pos: false,
      cancel_bill: false,
      clear_bill: false,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "การขาย",
          disabled: false,
          href: "#",
        },
      ],
      productList: [],
      productList_data: [],
      headers_product: [
        {
          text: "รหัสสินค้า",
          value: "id_product",
          fixed: true,
        },
        {
          text: "ชื่อสินค้า",
          value: "product_name",
          fixed: true,
          align: "center",
        },
        {
          text: "ชื่อทางการแพทย์",
          value: "name_sci",
          fixed: true,
        },
        {
          text: "ประเภท",
          value: "type_name",
          fixed: true,
          sortable: false,
        },
      ],
      headers: [
        {
          text: "ลบ",
          value: "",
          fixed: true,
          sortable: false,
        },
        {
          text: "บาร์โค๊ด",
          value: "",
          fixed: true,
        },
        {
          text: "ชื่อสินค้า",
          value: "",
          fixed: true,
        },
        {
          text: "จำนวน",
          value: "",
          fixed: true,
          align: "center",
        },
        {
          text: "หน่วยนับ",
          value: "",
          fixed: true,
          align: "center",
        },
        {
          text: "ราคา",
          value: "",
          fixed: true,
        },
        {
          text: "ส่วนลด",
          value: "",
          fixed: true,
          align: "center",
        },
        {
          text: "ยอดรวม",
          value: "",
          fixed: true,
          sortable: false,
        },
      ],
      card_data: [
        { id: 1, type: "เงินสด", icon: "mdi-cash" },
        { id: 2, type: "เงินโอน", icon: "mdi-cellphone-cog" },
        { id: 5, type: "Qr Code", icon: "mdi-qrcode-scan" },
        { id: 3, type: "บัตรเครดิต", icon: "mdi-credit-card" },
        { id: 4, type: "อื่นๆ", icon: "mdi-dots-horizontal" },
      ],
      // เปิดรอบการขาย
      init_money_amount: null,
      user_List: [],
      user_id: null,
      owner_id: null,
      round_id: null,
      telephone: null,
      product_data: [],
      username: null,
      customer_id: null,
      customer_register: {
        fullname: null,
        tel: null,
        tax_number: null,
        address: null,
        province_data: null,
        note: null,
        branch_number: null,
      },
      payment_data: {
        customer_id: null,
        customer_name: null,
        customer_tel: null,
        customer_point: 0,
        payment_cash: null,
        payment_pay: null,
        payment_qrcode: null,
        payment_credit: null,
        payment_other: null,
        pay_note:null,
        reason: null,
        use_point: 0,
      },
      customer_name: null,
      customer_note: null,
      summary: 0,
      discount: 0,
      discount_last: 0,
      net: 0,
      test: {},
      invoiceList: [],
      cancel: {
        invoice_id: null,
        note: null,
        tel: null,
        password: null,
      },
      product_list: [],
      invoice_id: null,
      invoice_code: null,
      promotion_discount: 0,
      //pagination
      page: 1,
      page_all: null,
      start_page: null,
      end_page: null,
      check_page: 0,
      search: "",
      vat_type: null,
      credit_id: null,
      credit_status: null,
      credit_charge: 0,
      interval: null,
      colClass: "col-10",
      widthClass: "w-10px",
      showHiddenDiv: true,
      newMessage: {
        product_data: [],
        customer_data: {},
        promotion: [],
      },
      socket: null,
      socket_code: null,
      store_name: null,
      ip: null,
      messages: [],
      credit_type_list: [],
      owner_data: {},
      vat_selection: 0,
      vat_defualt: null,
      round_status: true,
      product_type_list: 0,
      memberList: [],
      product_value: null,
      focus: true,
      value: null,
      not_found: false,
    };
  },
  methods: {
    // checkLength() {
    //   if (this.value) {
        
    //       this.addItem(this.value); // เรียกฟังก์ชัน addItem เมื่อเงื่อนไขตรง
        
    //   } else {
       
    //       this.addItem(this.product_value); // เรียกฟังก์ชัน addItem เมื่อเงื่อนไขตรง
        
    //   }
    // },
    setLoading(isLoading) {
      if (isLoading) {
        this.loading_page_counter++;
        this.loading_page = true;
      } else {
        this.loading_page_counter--;
        if (this.loading_page_counter <= 0) {
          this.loading_page = false;
        }
      }
    },

    formatItemText(item) {
      if (!item) {
        return ""; // กรณีที่ item เป็น null หรือ undefined
      }

      const name = item.name || ""; // ถ้าไม่มี name ให้ใช้ค่าว่าง
      const tel = item.tel || "";   // ถ้าไม่มี tel ให้ใช้ค่าว่าง

      if (name && tel) {
        return `${name} ${tel}`; // แสดงทั้งชื่อและเบอร์โทร
      } else if (name) {
        return name; // แสดงเฉพาะชื่อ
      } else if (tel) {
        return tel; // แสดงเฉพาะเบอร์โทร
      }

      return ""; // ถ้าไม่มีข้อมูลเลย
    },


    getCustomer() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/warehouse/memberandemployee", config).then((response) => {
        if (response.data.successful === true) {
          this.memberList = response.data.data;
          // console.log("this.memberList",this.memberList);

          // this.memberList = this.memberList.map(item =>{
          //   return {
          //     ...item,
          //     name:item.type_user == "employee" ? item.name + '-- พนักงาน' : item.name + '-สมาชิก'
          //   }
          // })
        }
      });
    },
    async getFocusScaner() {
      this.isLoading = false;
      this.focus = true;
      await this.$refs.product_list.focus();
      this.in_stock = false;
      // this.not_found = false;
      this.isLoading = true;
    },
    customSearch: (item, queryText) => {
      const searchText = queryText.toLowerCase();

      return (
        item.name.toLowerCase().includes(searchText) ||
        item.name_sci.toLowerCase().includes(searchText) ||
        item.unit_name.toLowerCase().includes(searchText) ||
        item.barcode.toString().includes(searchText) // Convert barcode to string for comparison
      );
    },
    async openCashDrawer() {
      const printContent = "";
      const printFrame = this.$refs.printFrame;
      printFrame.contentDocument.open();
      printFrame.contentDocument.write(printContent);
      printFrame.contentDocument.close();
      printFrame.contentWindow.print();
    },
    async creditList() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/creditcard/list", config).then((res) => {
        if (res.data.successful === true) {
          this.credit_type_list = res.data.data;
        }
      });
    },
    genarateSocketCode(length) {
      const charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
      let password = "";

      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        password += charset[randomIndex];
      }

      return password;
    },
    async sendMessage() {
      this.newMessage = {
        product_data: this.product_data,
        payment_data: this.payment_data,
        promotion_discount: this.promotion_discount,
        discount_last: this.discount_last,
        cost:
          this.vat_type == 0
            ? parseFloat(
                this.summary -
                  this.discount -
                  this.promotion_discount -
                  this.discount_last
              ) *
              (100 / 107)
            : this.vat_type == 1
            ? parseFloat(
                this.summary -
                  this.discount -
                  this.promotion_discount -
                  this.discount_last
              )
            : this.vat_type == 2
            ? parseFloat(
                this.summary -
                  this.discount -
                  this.promotion_discount -
                  this.discount_last
              )
            : 0,
        total:
          this.vat_type == 0
            ? parseFloat(
                this.summary -
                  this.discount -
                  this.promotion_discount -
                  this.discount_last
              ) *
              (100 / 107)
            : this.vat_type == 1
            ? parseFloat(
                this.summary -
                  this.discount -
                  this.promotion_discount -
                  this.discount_last
              )
            : this.vat_type == 2
            ? parseFloat(
                this.summary -
                  this.discount -
                  this.promotion_discount -
                  this.discount_last
              )
            : 0,
        vat:
          this.vat_type == 0
            ? this.summary -
              this.discount -
              this.promotion_discount -
              this.discount_last -
              (this.summary -
                this.discount -
                this.promotion_discount -
                this.discount_last) *
                (100 / 107)
            : this.vat_type == 1
            ? ((this.summary -
                this.discount -
                this.promotion_discount -
                this.discount_last) *
                7) /
              100
            : this.vat_type == 2
            ? 0
            : 0,
        credit_charge:
          parseFloat(this.payment_data.payment_credit) * this.credit_charge,
        pay_type: this.chk_id,
        credit_status: this.credit_status,
        credit_percent: this.credit_charge * 100,
        net:
          this.chk_id.find((o) => o === 3) && this.credit_status == 1
            ? parseFloat(this.net) +
              parseFloat(
                this.payment_data.payment_credit == null ||
                  this.payment_data.payment_credit == ""
                  ? 0
                  : this.payment_data.payment_credit
              ) *
                this.credit_charge -
              parseFloat(
                (this.payment_data.use_point =
                  null || this.payment_data.use_point == ""
                    ? 0
                    : this.payment_data.use_point)
              )
            : (await parseFloat(this.net)) -
              parseFloat(
                (this.payment_data.use_point =
                  null || this.payment_data.use_point == ""
                    ? 0
                    : this.payment_data.use_point)
              ),
        pay:
          parseFloat(
            this.payment_data.payment_cash == "" ||
              this.payment_data.payment_cash == null
              ? 0
              : this.payment_data.payment_cash
          ) +
          parseFloat(
            this.payment_data.payment_pay == "" ||
              this.payment_data.payment_pay == null
              ? 0
              : this.payment_data.payment_pay
          ) +
          parseFloat(
            this.payment_data.payment_credit == "" ||
              this.payment_data.payment_credit == null
              ? 0
              : this.payment_data.payment_credit
          ) +
          parseFloat(
            this.payment_data.payment_other == "" ||
              this.payment_data.payment_other == null
              ? 0
              : this.payment_data.payment_other
          ) +
          parseFloat(
            this.payment_data.payment_qrcode == "" ||
              this.payment_data.payment_qrcode == null
              ? 0
              : this.payment_data.payment_qrcode
          ),
        change:
          this.credit_status == 1 && this.chk_id.find((o) => o === 3)
            ? 0
            : parseFloat(
                this.payment_data.payment_cash == "" ||
                  this.payment_data.payment_cash == null
                  ? 0
                  : this.payment_data.payment_cash
              ) +
              parseFloat(
                this.payment_data.payment_pay == "" ||
                  this.payment_data.payment_pay == null
                  ? 0
                  : this.payment_data.payment_pay
              ) +
              parseFloat(
                this.payment_data.payment_credit == "" ||
                  this.payment_data.payment_credit == null
                  ? 0
                  : this.payment_data.payment_credit
              ) +
              parseFloat(
                this.payment_data.payment_other == "" ||
                  this.payment_data.payment_other == null
                  ? 0
                  : this.payment_data.payment_other
              ) +
              parseFloat(
                this.payment_data.payment_qrcode == "" ||
                  this.payment_data.payment_qrcode == null
                  ? 0
                  : this.payment_data.payment_qrcode
              ) -
              (this.credit_status == 1 && this.chk_id.find((o) => o === 3)
                ? parseFloat(this.net) +
                  parseFloat(this.net) * parseFloat(this.credit_charge) -
                  parseFloat(
                    this.payment_data.use_point == null ||
                      this.payment_data.use_point == ""
                      ? 0
                      : this.payment_data.use_point
                  )
                : parseFloat(this.net) -
                  parseFloat(
                    this.payment_data.use_point == null ||
                      this.payment_data.use_point == ""
                      ? 0
                      : this.payment_data.use_point
                  )),
        store_name: this.store_name,
      };
      if (this.newMessage !== "") {
        let data = {
          code: this.socket_code,
          text: await this.newMessage,
        };
        this.socket.emit("Monitor", data);
        this.newMessage = "";
      }
    },
    toggleColAndDiv() {
      // Toggle the class name for v-col
      this.colClass = this.colClass === "col-12" ? "col-9" : "col-12";
      this.widthClass = this.colClass === "col-12" ? "w-10px" : "w-45px";
      // Toggle the visibility of the hidden div
      this.showHiddenDiv = !this.showHiddenDiv;
    },
    link(link) {
      window.location.href = link;
    },
    open_model_bill_success() {
      this.show_check_bill_success = true;
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    async removeProduct(index) {
      this.product_data.splice(index, 1);
      // ใช้ type_user เพื่อตัดสินราคาที่ต้องใช้
      this.product_data = this.product_data.map(item => {
        let price = item.price_standard_old;

        if (this.type_user === 1 && item.price_register != null) {
          price = item.price_register;
        } else if (this.type_user === 2 && item.price_employee != null) {
          price = item.price_employee;
        }

        return {
          ...item,
          price_standard: price,
          total_price_non: parseFloat(item.qty) * parseFloat(price),
          total_price: parseFloat(item.qty) * parseFloat(price) - parseFloat(item.discount || 0),
        };
      });
      // this.telephone = "";
      // this.customer_name = null;
      await this.calculate_last();
      await this.sendMessage();
    },
    selectItem(item) {
      if (item.id) {
        if (item.id === this.user_id) {
          this.user_id = null; // Deselect the item if it's already selected
        } else {
          this.user_id = item.id; // Select the clicked item
        }
      }
      if (item.owner_id) {
        if (this.owner_id != null) {
          this.owner_id = null; // Deselect the item if it's already selected
        } else {
          this.owner_id = item.owner_id; // Select the clicked item
        }
      }
    },
    close_model_all() {
      this.show_check_bill_success = false;
    },
    reset_all() {
      this.product_data.splice(0);
      this.telephone = null;
      this.restart_pos = false;
      this.customer_name = null;
      this.customer_note = null;
      this.summary = 0;
      this.discount = 0;
      this.discount_last = 0;
      this.net = 0;
      this.customer_register.fullname = null;
      this.customer_register.tax_number = null;
      this.customer_register.tel = null;
      this.customer_register.address = null;
      this.customer_register.province_data = null;
      this.customer_register.branch_number = null;
      this.payment_data.customer_point = null;
      this.payment_data.payment_cash = null;
      this.payment_data.payment_pay = null;
      this.payment_data.payment_qrcode = null;
      this.payment_data.payment_credit = null;
      this.payment_data.payment_other = null;
      this.payment_data.pay_note = null;
      this.payment_data.reason = null;
      this.payment_data.use_point = 0;
      this.payment_data.customer_name = null;
      this.payment_data.customer_id = null;
      this.payment_data.customer_tel = null;
      this.$store.commit("clearInvoice");
      this.$store.commit("clearMonitor");
      this.sendMessage();
    },
    tab_cash(evt) {
      this.loading_page = true;
      const ch_arr = this.chk_id.includes(evt);
      if (ch_arr == true) {
        this.chk_id = this.chk_id.filter((id) => id != evt);
      }
      if (ch_arr == false) {
        if (this.chk_id.length >= 2) {
          this.chk_id.splice(0, 1);
          this.chk_id.push(evt);
        } else {
          this.chk_id.push(evt);
        }
      }
      this.payment_data.payment_cash = null;
      this.payment_data.payment_pay = null;
      this.payment_data.payment_qrcode = null;
      this.payment_data.payment_credit = null;
      this.payment_data.payment_other = null;
      this.payment_data.pay_note = null;
      this.payment_data.reason = null;
      this.loading_page = false;
    },
    addQuantity(index) {
      this.product_data[index].qty =
        parseFloat(this.product_data[index].qty) + 1;
      this.product_data[index].total_price =
        parseFloat(this.product_data[index].qty) *
        parseFloat(this.product_data[index].price_standard);
      this.sendMessage();

       // ✅ โฟกัสกลับช่องยิงบาร์โค้ด
      this.$nextTick(() => {
        this.$refs.product_list?.focus();
      });
    },
    subtractQuantity(index) {
      if (this.product_data[index].qty > 0) {
        this.product_data[index].qty =
          parseFloat(this.product_data[index].qty) - 1;
        this.product_data[index].total_price =
          parseFloat(this.product_data[index].qty) *
          parseFloat(this.product_data[index].price_standard);
        this.sendMessage();

        // ✅ โฟกัสกลับช่องยิงบาร์โค้ด
        this.$nextTick(() => {
          this.$refs.product_list?.focus();
        });
      }
    },
    // parseFloat(this.product_data[index].total_price_non * 0.1)
    calculate(index) {
      if (
        parseFloat(this.product_data[index].total_price_non) <
        parseFloat(
          this.product_data[index].discount == ""
            ? 0
            : this.product_data[index].discount
        )
      ) {
        this.$nextTick(() => {
          this.product_data[index].discount = parseFloat(0);
          this.product_data[index].total_price =
            parseFloat(
              this.product_data[index].qty == ""
                ? 0
                : this.product_data[index].qty
            ) *
            parseFloat(
              this.product_data[index].price_standard == null ||
                this.product_data[index].price_standard == ""
                ? 0
                : this.product_data[index].price_standard
            );
          this.product_data[index].total_price =
            parseFloat(this.product_data[index].total_price) -
            parseFloat(
              this.product_data[index].discount == ""
                ? 0
                : this.product_data[index].discount
            );
          this.product_data[index].total_price_non =
            parseFloat(
              this.product_data[index].qty == ""
                ? 0
                : this.product_data[index].qty
            ) *
            parseFloat(
              this.product_data[index].price_standard == null ||
                this.product_data[index].price_standard == ""
                ? 0
                : this.product_data[index].price_standard
            );
            this.alert_error = true;
            this.alert_message_error = "ห้ามกรอกส่วนลดเกินราคาขาย";
            setTimeout(() => this.alert_error = false, 3000);
            this.calculate_last();
        });
      } else {
        this.product_data[index].total_price =
          parseFloat(
            this.product_data[index].qty == ""
              ? 0
              : this.product_data[index].qty
          ) *
          parseFloat(
            this.product_data[index].price_standard == null ||
              this.product_data[index].price_standard == ""
              ? 0
              : this.product_data[index].price_standard
          );
        this.product_data[index].total_price =
          parseFloat(this.product_data[index].total_price) -
          parseFloat(
            this.product_data[index].discount == ""
              ? 0
              : this.product_data[index].discount
          );
        this.product_data[index].total_price_non =
          parseFloat(
            this.product_data[index].qty == ""
              ? 0
              : this.product_data[index].qty
          ) *
          parseFloat(
            this.product_data[index].price_standard == null ||
              this.product_data[index].price_standard == ""
              ? 0
              : this.product_data[index].price_standard
          );
        this.calculate_last();
      }
    },
    calculate_last() {
      // let maxDiscount = this.summary * 0.1;
      let maxDiscount = this.summary;
      if (this.discount_last > maxDiscount) {
        this.discount_last = maxDiscount;
      }
      if (this.summary - this.discount <= this.discount_last) {
        this.$nextTick(() => {
          // this.discount_last = parseFloat(this.discount_last >= this.summary*0.1 ? 0 : this.discount_last);

          this.summary = 0;
          this.discount = 0;
          for (let i = 0; i < this.product_data.length; i++) {
            this.summary += parseFloat(this.product_data[i].total_price_non);
            this.discount += parseFloat(
              this.product_data[i].discount == ""
                ? 0
                : this.product_data[i].discount
            );
          }
          let discount_all =
            parseFloat(this.discount_last == "" ? 0 : this.discount_last) +
            parseFloat(this.discount) +
            parseFloat(this.promotion_discount);
          this.net = this.summary - parseFloat(discount_all);
          if (this.vat_type == 1) {
            this.net = this.net + (this.payment_data.payment_credit * 7) / 100;
          }
        });
      } else {
        this.summary = 0;
        this.discount = 0;
        for (let i = 0; i < this.product_data.length; i++) {
          this.summary += parseFloat(this.product_data[i].total_price_non);
          this.discount += parseFloat(
            this.product_data[i].discount == ""
              ? 0
              : this.product_data[i].discount
          );
        }
        let discount_all =
          parseFloat(this.discount_last == "" ? 0 : this.discount_last) +
          parseFloat(this.discount) +
          parseFloat(this.promotion_discount);
        this.net = this.summary - parseFloat(discount_all);
        if (this.vat_type == 1) {
          this.net = this.net + (this.net * 7) / 100;
        }
      }
      this.sendMessage();
    },
    getAddress_api() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/stores/addresslist", config).then((res) => {
        if (res.data.successful === true) {
          this.addressList = res.data.addressList;
        }
      });
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number);
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number);
    },
    isPaste: function (evt) {
      return onPaste(evt);
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number);
    },
    init_store() {
      if (this.$refs.upload.validate()) {
        let config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        const data = {
          init_money_amount: this.init_money_amount,
        };
        HTTP_ARIN.post("/pos/init/round", data, config).then((res) => {
          if (res.data.successful === true) {
            this.round_id = res.data.round_id;
            this.round_status = 1;
            this.alert_success = true;
            this.alert_message_success = "เปิดรอบการขายสำเร็จ";
            this.dialog_open_pos = false;
            setTimeout(() => {
              this.alert_success = false;
              window.location.reload();
            }, 1000);
          } else {
            this.alert_error = true;
            this.alert_message_error =
              "ไม่สามารถเปิดรอบการขายได้ กรุณาลองใหม่อีกครั้ง.";
            setTimeout(() => {
              this.alert_error = false;
              window.location.reload();
            }, 2000);
          }
        });
      }
    },
    openPOS() {
      var newWindow = window.open(
        "/arin/pos/posmonitor",
        "_blank",
        "fullscreen=yes,scrollbars=no,toolbar=no,location=no"
      );
      if (newWindow) {
        newWindow.moveTo(0, 0);
        newWindow.resizeTo(screen.width, screen.height);
      }
    },
    closeWindowPos() {
      window.location.href = '/arin/pos/posbillafter';
    },
    async getCheckUser(value) {
      if (value != null) {
        let config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        await HTTP_ARIN.get("/pos/usercheck/" + value, config).then(
          async (res) => {
            if (res.data.successful === true) {
              console.log(res.data);
              
              this.product_data = this.product_data.map((item) => {
                return {
                  ...item,
                  price_standard:
                    res.data.type_user == 1
                      ? item.price_register
                      : item.price_employee,
                  total_price_non:
                    res.data.type_user == 1
                      ? item.price_register == null || item.price_register == ""
                        ? 0
                        : parseFloat(item.qty) * parseFloat(item.price_register)
                      : item.price_employee == null || item.price_employee == ""
                      ? 0
                      : parseFloat(item.qty) * parseFloat(item.price_employee),
                  total_price:
                    res.data.type_user == 1
                      ? item.price_register == null || item.price_register == ""
                        ? 0
                        : parseFloat(item.qty) * parseFloat(item.price_register)
                      : item.price_employee == null || item.price_employee == ""
                      ? 0
                      : parseFloat(item.qty) * parseFloat(item.price_employee),
                };
              });
              this.customer_name = res.data.data.name;
              this.customer_note = res.data.data.note;
              this.payment_data.customer_id = res.data.data.id;
              this.payment_data.customer_name = res.data.data.name;
              this.payment_data.customer_tel = res.data.data.tel_number;
              this.payment_data.customer_point = res.data.data.point;
              this.type_user = res.data.type_user;  // 1 = สมาชิก, 2 = พนักงาน
              console.log(this.type_user);
              
              this.calculate_last();
            }
          }
        );
      } else {
        this.product_data = await this.product_data.map((item) => {
          return {
            ...item,
            price_standard: item.price_standard_old,
            total_price_non:
              parseFloat(item.qty) * parseFloat(item.price_standard_old),
            total_price:
              parseFloat(item.qty) * parseFloat(item.price_standard_old),
          };
        });
        this.customer_name = null;
        this.customer_id = null;
        this.payment_data.customer_name = null;
        this.payment_data.customer_id = null;
        this.payment_data.customer_tel = null;
        this.payment_data.customer_point = 0;
        this.payment_data.use_point = 0;
      }
      this.sendMessage();
    },
    async getStatusRoandSell() {
      this.setLoading(true);
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/pos/checkroundinvoice", config).then((res) => {
        if (res.data.successful === true) {
          this.dialog_open_pos = res.data.round_status == 0 ? true : false;
          this.round_status = res.data.round_status == 0 ? true : false;
          this.round_id = res.data.round_id;
          this.username =
            res.data.user_edit != null
              ? res.data.user_edit
              : res.data.owner_edit;
          this.customer_id = res.data.user_edit_id;
          this.user_id = res.data.user_edit_id;
          this.owner_id = res.data.owner_edit_id;
          this.getInvoice();
          this.setLoading(false);
        }
      });
    },
    async vatType() {
      this.setLoading(true);
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let store_id = this.$store.state.store_arin.user_data.store_id;
      await HTTP_ARIN.get("/stores/detail/" + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.vat_type = res.data.storeDetail.vat;
          this.vat_selection = res.data.storeDetail.vat;
          this.vat_defualt = res.data.storeDetail.vat;
          this.owner_data = {
            owner_id: res.data.storeDetail.owner_id,
            owner_name: res.data.storeDetail.owner_name,
          };
          this.store_name = res.data.storeDetail.store_name;
          this.credit_status = res.data.storeDetail.credit_charge_status;
          this.credit_charge =
            parseFloat(
              res.data.storeDetail.credit_charge == null
                ? 0
                : res.data.storeDetail.credit_charge
            ) / 100;
          this.setLoading(false);
          this.$store.commit("getSocket", {
            socket_code: this.socket_code,
            store_name: this.store_name,
            credit_percent: this.credit_charge * 100,
          });
        }
      });
    },
    async userList() {
      this.setLoading(true);
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/pos/get/list/employee", config).then((res) => {
        if (res.data.successful === true) {
          this.user_List = res.data.data;
          this.setLoading(false);
        }
      });
    },
    async addItem(barcode) {
      
      this.focus = false;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get(
        `/pos/barcodecheck/${barcode}?type_product=${this.product_type_list}`,
        config
      ).then(async (res) => {
        if (res.data.successful === true) {
          
            // console.log(res.data.productPrice.in_stock)
            let price_to_use = res.data.productPrice.price_standard;

            if (this.type_user === 1) { // สมาชิก
              price_to_use = res.data.productPrice.price_register ?? res.data.productPrice.price_standard;
            } else if (this.type_user === 2) { // พนักงาน
              price_to_use = res.data.productPrice.price_employee ?? res.data.productPrice.price_standard;
            }

            let check = this.product_data.find((o) => o.barcode === barcode);

            if (check == null) {

              this.product_data.push({
                id: res.data.productPrice.id,
                barcode: res.data.productPrice.barcode,
                product_code: res.data.productPrice.product_code,
                name: res.data.productPrice.name,
                unit_id: res.data.productPrice.unit_id,
                unit_name: res.data.productPrice.unit_name,
                qty_unit: res.data.productPrice.qty_unit,
                price_standard: price_to_use,
                price_standard_old: res.data.productPrice.price_standard,
                price_register: res.data.productPrice.price_register,
                price_register_old: res.data.productPrice.price_register,
                price_employee: res.data.productPrice.price_employee,
                price_employee_old: res.data.productPrice.price_employee,
                promotion_code: res.data.productPrice.promotion_code,
                product_expired_id: res.data.productPrice.product_expired_id,
                discount: 0,
                qty: 1,
                in_stock: res.data.productPrice.in_stock,
                total_price: 0,
                total_price_non: 0,
                index_group: this.product_data.length,
              });
              this.calculate(this.product_data.length - 1);
              if (
                res.data.productPrice.in_stock <
                parseFloat(
                  this.product_data[this.product_data.length - 1].qty
                ) *
                  parseFloat(
                    this.product_data[this.product_data.length - 1].qty_unit
                  )
              ) {
                this.in_stock = true;
              }
            } else {
              check.price_standard = price_to_use;
              check.price_register = res.data.productPrice.price_register;
              check.price_employee = res.data.productPrice.price_employee;
              this.product_data[check.index_group].qty =
                parseFloat(this.product_data[check.index_group].qty) + 1;
              this.calculate(check.index_group);
              if (
                res.data.productPrice.in_stock <
                parseFloat(this.product_data[check.index_group].qty) *
                  parseFloat(this.product_data[check.index_group].qty_unit)
              ) {
                this.in_stock = true;
              }
            }
            this.alert_success = true;
            this.alert_message_success = "เพิ่มสินค้าลงรายการสำเร็จ";
            // หุบ dropdown หลังจากเลือกข้อมูล
            this.$refs.product_list.blur();
             // ตั้งเวลาให้ focus กลับไปที่ autocomplete
            setTimeout(() => {
              this.$refs.product_list.focus();
            }, 200);
            setTimeout(() => (this.alert_success = false), 1000);
            // this.$refs.product_list.focus();
            this.in_stock_confirm = 0;
            this.product_value = null;
            this.value = null;
            this.$store.commit("getMonitor", this.product_data);
          
        } 
      });
      this.sendMessage();
    },
    async saveUser() {
      this.loading_page = true;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let data = {
        round_id: this.round_id,
        user_edit: this.user_id,
        owner_edit: this.owner_id,
      };
      await HTTP_ARIN.post("/pos/round/update/user/edit", data, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.alert_success = true;
            this.username = res.data.data;
            this.customer_id = this.user_id;
            this.alert_message_success = "บันทึกข้อมูลพนักงานเรียบร้อย";
            this.dialog_open_pos = false;
            this.open_customer = false;
            this.loading_page = false;
            setTimeout(() => (this.alert_success = false), 5000);
          }
        }
      );
    },
    async saveRegister() {
      if (this.$refs.register.validate()) {
        this.loading_page = true;
        let config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        let data = {
          member_name: this.customer_register.fullname,
          tax_number: this.customer_register.tax_number,
          tel_number: this.customer_register.tel,
          address: this.customer_register.address,
          branch_number: this.customer_register.branch_number,
          sub_district:
            this.customer_register.province_data == null ||
            this.customer_register.province_data == ""
              ? null
              : this.customer_register.province_data.split(",")[0],
          district:
            this.customer_register.province_data == null ||
            this.customer_register.province_data == ""
              ? null
              : this.customer_register.province_data.split(",")[1],
          province:
            this.customer_register.province_data == null ||
            this.customer_register.province_data == ""
              ? null
              : this.customer_register.province_data.split(",")[2],
          postcode:
            this.customer_register.province_data == null ||
            this.customer_register.province_data == ""
              ? null
              : this.customer_register.province_data.split(",")[3],
          note:
            this.customer_register.note == null ||
            this.customer_register.note == ""
              ? null
              : this.customer_register.note,
        };
        // this.test = data;
        await HTTP_ARIN.post("/member/add", data, config).then((res) => {
          if (res.data.successful === true) {
            this.customer_register.fullname = null;
            this.customer_register.tax_number = null;
            this.customer_register.tel = null;
            this.customer_register.address = null;
            this.customer_register.province_data = null;
            this.customer_register.branch_number = null;
            this.alert_success = true;
            this.alert_message_success = "บันทึกข้อมูลลูกค้าเรียบร้อย";
            this.dialog_register = false;
            this.loading_page = false;
            this.getCustomer();
            setTimeout(() => (this.alert_success = false), 5000);
          } else if (res.data.successful === false) {
            this.loading_page = false;
            this.alert_error = true;
            this.alert_message_error = res.data.message;
            setTimeout(() => (this.alert_error = false), 5000);
          }
        });
      }
    },
    async getProductList() {
      this.setLoading(true);
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get(
        `/pos/round/get/productlist?type_product=${this.product_type_list}`,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.productList = res.data.productPrice;
          this.pagetination(0, 10);
          this.setLoading(false);
        }
      });
    },
    async pagetination(start = null, end = null, search = "") {
      this.end_page = end;
      this.check_page = this.page;
      this.start_page = start;
      let text = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const pattern = new RegExp(text, "i");
      let productList_data = this.productList.filter(
        (item) =>
          pattern.test(`${item.name} (${item.unit_name})`) || 
          pattern.test(item.name_sci) ||
          pattern.test(item.product_code)
      );
      this.productList_data = productList_data.filter(
        (item, index) =>
          index >= parseFloat(this.start_page) &&
          index < parseFloat(this.end_page)
      );
      this.page_all = Math.ceil(
        parseFloat(productList_data.length) / parseFloat(10)
      );
    },
    checkPoint() {
      this.loading_page = true;
      if (
        parseFloat(this.payment_data.customer_point) <
        parseFloat(this.payment_data.use_point)
      ) {
        this.$nextTick(() => {
          this.payment_data.use_point = null;
          this.payment_data.use_point = parseFloat(
            this.payment_data.customer_point
          );
        });
      }
      this.sendMessage();
      this.loading_page = false;
    },
    async saveData(status) {
      // status = บันทึกข้อมูลตอนกดปุ่ม รับเงิน
      this.loading_page = true;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let product_list = this.product_data.map((item) => {
        return {
          product_code: item.product_code,
          promotion_code: item.promotion_code,
          unit_id: parseFloat(item.unit_id),
          qty: parseFloat(item.qty),
          price: parseFloat(item.price_standard),
          discount: parseFloat(item.discount),
          total: parseFloat(item.total_price),
          product_expired_id: parseFloat(item.product_expired_id),
          stock_cut: parseFloat(item.qty) * parseFloat(item.qty_unit),
        };
      });
      let data = {
        invoice: {
          customer_id: this.payment_data.customer_id,
          round_total_invoice_id: parseFloat(this.round_id),
          // cost:parseFloat(this.summary),
          // vat:parseFloat(this.summary - (this.summary * (100/107))),
          total: parseFloat(this.summary - this.discount),
          // discount:parseFloat(this.discount_last),
          pay_type: status == 0 ? [] : status == 1 ? [0] : "",
          cash: parseFloat(
            this.payment_data.payment_cash == "" ||
              this.payment_data.payment_cash == null
              ? 0
              : this.payment_data.payment_cash
          ),
          payment: parseFloat(
            this.payment_data.payment_pay == "" ||
              this.payment_data.payment_pay == null
              ? 0
              : this.payment_data.payment_pay
          ),
          credit: parseFloat(
            this.payment_data.payment_credit == "" ||
              this.payment_data.payment_credit == null
              ? 0
              : this.payment_data.payment_credit
          ),
          etc_payment: parseFloat(
            this.payment_data.payment_other == "" ||
              this.payment_data.payment_other == null
              ? 0
              : this.payment_data.payment_other
          ),
          qrcode_pay: parseFloat(
            this.payment_data.payment_qrcode == "" ||
              this.payment_data.payment_qrcode == null
              ? 0
              : this.payment_data.payment_qrcode
          ),
          use_point: 0,
          point: 0,
          pay:
            parseFloat(
              this.payment_data.payment_cash == "" ||
                this.payment_data.payment_cash == null
                ? 0
                : this.payment_data.payment_cash
            ) +
            parseFloat(
              this.payment_data.payment_pay == "" ||
                this.payment_data.payment_pay == null
                ? 0
                : this.payment_data.payment_pay
            ) +
            parseFloat(
              this.payment_data.payment_credit == "" ||
                this.payment_data.payment_credit == null
                ? 0
                : this.payment_data.payment_credit
            ) +
            parseFloat(
              this.payment_data.payment_other == "" ||
                this.payment_data.payment_other == null
                ? 0
                : this.payment_data.payment_other
            ) +
            parseFloat(
              this.payment_data.payment_qrcode == "" ||
                this.payment_data.payment_qrcode == null
                ? 0
                : this.payment_data.payment_qrcode
            ),
          change:
            this.credit_status == 1 && this.chk_id.find((o) => o === 3)
              ? 0
              : parseFloat(
                  this.payment_data.payment_cash == "" ||
                    this.payment_data.payment_cash == null
                    ? 0
                    : this.payment_data.payment_cash
                ) +
                parseFloat(
                  this.payment_data.payment_pay == "" ||
                    this.payment_data.payment_pay == null
                    ? 0
                    : this.payment_data.payment_pay
                ) +
                parseFloat(
                  this.payment_data.payment_credit == "" ||
                    this.payment_data.payment_credit == null
                    ? 0
                    : this.payment_data.payment_credit
                ) +
                parseFloat(
                  this.payment_data.payment_other == "" ||
                    this.payment_data.payment_other == null
                    ? 0
                    : this.payment_data.payment_other
                ) +
                parseFloat(
                  this.payment_data.payment_qrcode == "" ||
                    this.payment_data.payment_qrcode == null
                    ? 0
                    : this.payment_data.payment_qrcode
                ) -
                parseFloat(this.net),
          status: status,
          user_create: this.user_id,
          owner_create: this.owner_id,
          ip: this.ip,
          invoice_id: this.invoice_id,
          invoice_code: this.invoice_code,
          reason:
            this.payment_data.reason == null ||
            String(this.payment_data.reason).trim() === ""
              ? null
              : String(this.payment_data.reason).trim(),
        },
        detail: product_list,
      };
      await HTTP_ARIN.post("/pos/invoice/save", data, config).then((res) => {
        if (res.data.successful === true) {
          switch (status) {
            case 0:
              this.invoice_id = res.data.invoice_id;
              this.checkPromotion(res.data.invoice_code);
              this.invoice_code = res.data.invoice_code;
              // this.dialog_cash_success = true
              break;
            case 1:
              this.stop_pos = false;
              this.reset_all();
              break;
          }
          this.$store.commit("clearInvoice");
          this.loading_page = false;
        }
      });
    },
    async checkPromotion(invoice_code) {
      this.net = 0;
      this.promotion_discount = 0;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get(`/pos/check/promotion/${invoice_code}`, config).then(
        (res) => {
          if (res.data.successful === true) {
            let promotion_list = res.data.promotion_list;
            this.product_list = [];
            promotion_list.forEach((detail) => {
              this.product_list.push({
                ...detail,
              });
              if (detail.id == null) {
                this.net -= detail.total;
                this.promotion_discount += detail.total;
              }
            });
            this.calculate_last();
            this.dialog_cash = true;
            this.sendMessage();
          }
        }
      );
    },
    async updateData() {
      if (this.$refs.payment.validate()) {
        if (
          this.chk_id.find((o) => o === 3)
            ? parseFloat(this.net) +
                (parseFloat(this.net) * this.credit_status == 1
                  ? this.credit_charge
                  : 0) -
                parseFloat(this.payment_data.use_point) >
              parseFloat(
                this.payment_data.payment_cash == "" ||
                  this.payment_data.payment_cash == null
                  ? 0
                  : this.payment_data.payment_cash
              ) +
                parseFloat(
                  this.payment_data.payment_pay == "" ||
                    this.payment_data.payment_pay == null
                    ? 0
                    : this.payment_data.payment_pay
                ) +
                parseFloat(
                  this.payment_data.payment_credit == "" ||
                    this.payment_data.payment_credit == null
                    ? 0
                    : this.payment_data.payment_credit
                ) +
                parseFloat(
                  this.payment_data.payment_other == "" ||
                    this.payment_data.payment_other == null
                    ? 0
                    : this.payment_data.payment_other
                ) +
                parseFloat(
                  this.payment_data.payment_qrcode == "" ||
                    this.payment_data.payment_qrcode == null
                    ? 0
                    : this.payment_data.payment_qrcode
                )
            : parseFloat(this.net) - parseFloat(this.payment_data.use_point) >
              parseFloat(
                this.payment_data.payment_cash == "" ||
                  this.payment_data.payment_cash == null
                  ? 0
                  : this.payment_data.payment_cash
              ) +
                parseFloat(
                  this.payment_data.payment_pay == "" ||
                    this.payment_data.payment_pay == null
                    ? 0
                    : this.payment_data.payment_pay
                ) +
                parseFloat(
                  this.payment_data.payment_credit == "" ||
                    this.payment_data.payment_credit == null
                    ? 0
                    : this.payment_data.payment_credit
                ) +
                parseFloat(
                  this.payment_data.payment_other == "" ||
                    this.payment_data.payment_other == null
                    ? 0
                    : this.payment_data.payment_other
                ) +
                parseFloat(
                  this.payment_data.payment_qrcode == "" ||
                    this.payment_data.payment_qrcode == null
                    ? 0
                    : this.payment_data.payment_qrcode
                )
        ) {
          this.alert_error = true;
          this.alert_message_error = "จำนวนเงินไม่ครบถ้วน";
          setTimeout(() => (this.alert_error = false), 5000);
        } else {
          let config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
            },
          };
          let data = {
            invoice: {
              id: this.invoice_id,
              customer_id: this.payment_data.customer_id,
              invoice_code: this.invoice_code,
              round_total_invoice_id: parseFloat(this.round_id),
              cost:
                this.vat_type == 0
                  ? parseFloat(
                      this.summary -
                        this.discount -
                        this.discount_last -
                        this.promotion_discount
                    ) *
                    (100 / 107)
                  : this.vat_type == 1
                  ? parseFloat(
                      this.summary -
                        this.discount -
                        this.discount_last -
                        this.promotion_discount
                    )
                  : this.vat_type == 2
                  ? parseFloat(
                      this.summary -
                        this.discount -
                        this.discount_last -
                        this.promotion_discount
                    )
                  : 0,
              vat:
                this.vat_type == 0
                  ? this.summary -
                    this.discount -
                    this.promotion_discount -
                    this.discount_last -
                    parseFloat(
                      this.summary -
                        this.discount -
                        this.discount_last -
                        this.promotion_discount
                    ) *
                      (100 / 107)
                  : this.vat_type == 1
                  ? parseFloat(
                      this.summary -
                        this.discount -
                        this.discount_last -
                        this.promotion_discount
                    ) *
                    (7 / 100)
                  : this.vat_type == 2
                  ? 0
                  : 0,
              vat_type: parseFloat(this.vat_type),
              total: this.chk_id.find((o) => o === 3)
                ? parseFloat(this.net) +
                  parseFloat(
                    this.payment_data.payment_credit == null ||
                      this.payment_data.payment_credit == ""
                      ? 0
                      : this.payment_data.payment_credit
                  ) *
                    (this.credit_status == 1 ? this.credit_charge : 0)
                : parseFloat(this.net),
              discount: parseFloat(this.discount_last),
              pay_type: this.chk_id,
              cash: parseFloat(
                this.payment_data.payment_cash == "" ||
                  this.payment_data.payment_cash == null
                  ? 0
                  : this.payment_data.payment_cash
              ),
              payment: parseFloat(
                this.payment_data.payment_pay == "" ||
                  this.payment_data.payment_pay == null
                  ? 0
                  : this.payment_data.payment_pay
              ),
              credit: parseFloat(
                this.payment_data.payment_credit == "" ||
                  this.payment_data.payment_credit == null
                  ? 0
                  : parseFloat(this.payment_data.payment_credit) +
                      this.payment_data.payment_credit * this.credit_charge
              ),
              etc_payment: parseFloat(
                this.payment_data.payment_other == "" ||
                  this.payment_data.payment_other == null
                  ? 0
                  : this.payment_data.payment_other
              ),
              pay_note:this.payment_data.pay_note,
              reason:
                this.payment_data.reason == null ||
                String(this.payment_data.reason).trim() === ""
                  ? null
                  : String(this.payment_data.reason).trim(),
              qrcode_pay: parseFloat(
                this.payment_data.payment_qrcode == "" ||
                  this.payment_data.payment_qrcode == null
                  ? 0
                  : this.payment_data.payment_qrcode
              ),
              use_point: parseFloat(
                this.payment_data.use_point == null ||
                  this.payment_data.use_point == ""
                  ? 0
                  : this.payment_data.use_point
              ),
              point: this.chk_id.find((o) => o === 3)
                ? (
                    (parseFloat(this.net) +
                      parseFloat(this.net) *
                        (this.credit_status == 1 ? this.credit_charge : 0)) /
                      100 +
                    ""
                  ).split(".")[0]
                : parseFloat((parseFloat(this.net) / 100 + "").split(".")[0]),
              pay:
                parseFloat(
                  this.payment_data.payment_cash == "" ||
                    this.payment_data.payment_cash == null
                    ? 0
                    : this.payment_data.payment_cash
                ) +
                parseFloat(
                  this.payment_data.payment_pay == "" ||
                    this.payment_data.payment_pay == null
                    ? 0
                    : this.payment_data.payment_pay
                ) +
                parseFloat(
                  this.payment_data.payment_credit == "" ||
                    this.payment_data.payment_credit == null
                    ? 0
                    : this.payment_data.payment_credit
                ) +
                parseFloat(
                  this.payment_data.payment_other == "" ||
                    this.payment_data.payment_other == null
                    ? 0
                    : this.payment_data.payment_other
                ) +
                parseFloat(
                  this.payment_data.payment_qrcode == "" ||
                    this.payment_data.payment_qrcode == null
                    ? 0
                    : this.payment_data.payment_qrcode
                ),
              change:
                this.credit_status == 1 && this.chk_id.find((o) => o === 3)
                  ? 0
                  : parseFloat(
                      this.payment_data.payment_cash == "" ||
                        this.payment_data.payment_cash == null
                        ? 0
                        : this.payment_data.payment_cash
                    ) +
                    parseFloat(
                      this.payment_data.payment_pay == "" ||
                        this.payment_data.payment_pay == null
                        ? 0
                        : this.payment_data.payment_pay
                    ) +
                    parseFloat(
                      this.payment_data.payment_credit == "" ||
                        this.payment_data.payment_credit == null
                        ? 0
                        : this.payment_data.payment_credit
                    ) +
                    parseFloat(
                      this.payment_data.payment_other == "" ||
                        this.payment_data.payment_other == null
                        ? 0
                        : this.payment_data.payment_other
                    ) +
                    parseFloat(
                      this.payment_data.payment_qrcode == "" ||
                        this.payment_data.payment_qrcode == null
                        ? 0
                        : this.payment_data.payment_qrcode
                    ) -
                    (this.credit_status == 1 && this.chk_id.find((o) => o === 3)
                      ? parseFloat(this.net) +
                        parseFloat(
                          this.payment_data.payment_credit == null ||
                            this.payment_data.payment_credit == ""
                            ? 0
                            : this.payment_data.payment_credit
                        ) *
                          parseFloat(this.credit_charge) -
                        parseFloat(
                          this.payment_data.use_point == null ||
                            this.payment_data.use_point == ""
                            ? 0
                            : this.payment_data.use_point
                        )
                      : parseFloat(this.net) -
                        parseFloat(
                          this.payment_data.use_point == null ||
                            this.payment_data.use_point == ""
                            ? 0
                            : this.payment_data.use_point
                        )),
              status: 0,
              credit_id: this.chk_id.find((o) => o === 3)
                ? this.credit_id
                : null,
              credit_charge_status: this.credit_status,
              credit_charge: this.credit_charge * 100,
              user_create: this.customer_id,
              credit_uncharge:
                this.payment_data.payment_credit == null ||
                this.payment_data.payment_credit == ""
                  ? 0
                  : this.payment_data.payment_credit,
            },
            detail: this.product_list,
            vat: this.vat_selection,
          };
          // console.log('data',data);
          
          await HTTP_ARIN.post("/pos/update/invoice", data, config).then(
            (res) => {
              if (res.data.successful === true) {
                // this.dialog_cash = false
                // this.dialog_cash_success = true
                // this.$router.push('/arin/pos/posinvoicereceipt')
                //  const newTab = window.open('/arin/pos/posinvoicereceipt', "print", "width=1,height=1")
                //     newTab.onload = () => {
                this.chk_id = [];
                
                this.print_receipt = true;

                // };
              }
            }
          );
        }
      }
    },
    async removeBill_all() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      let id = this.round_id;
      await HTTP_ARIN.get(`/pos/clear/invoice/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          this.clear_bill = false;
          this.alert_success = true;
          this.alert_message_success = "ล้างใบเสร็จที่พักไว้ทั้งหมดสำเร็จ";
          setTimeout(() => (this.alert_success = false), 5000);
          this.show_check_clear_bill_success = true;
          setTimeout(() => (this.show_check_clear_bill_success = false), 3000);
        }
      });
    },
    async getInvoice() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.round_id;
      await HTTP_ARIN.get(
        `/pos/round/invoicelist/to/select/box/${id}`,
        config
      ).then((res) => {
        if (res.data.successful === true) {
          this.invoiceList = res.data.invoiceList;
          this.loading_page = false;
        }
      });
    },
    async saveCancelInvoice() {
      if (this.$refs.cancelBill.validate()) {
        let config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
          },
        };
        let data = {
          cancel_note: this.cancel.note,
          tel: this.cancel.tel,
          password: this.cancel.password,
        };
        await HTTP_ARIN.post(
          `/pos/invoice/cancle/${this.cancel.invoice_id}`,
          data,
          config
        ).then((res) => {
          if (res.data.successful === true) {
            this.print_receipt = true;
            // this.cancel.invoice_id = null;
            this.cancel.note = null;
            this.cancel.tel = null;
            this.cancel.password = null;
            this.cancel_bill = false;
            this.getInvoice();
            this.alert_success = true;
            this.alert_message_success = "ยกเลิกใบเสร็จเรียบร้อยแล้ว";
            this.show_check_bill_success = true;
            setTimeout(() => (this.show_check_bill_success = false), 3000);
            setTimeout(() => (this.alert_success = false), 5000);
            this.loading_page = false;
          } else if (res.data.successful === false) {
            this.alert_error = true;
            this.alert_message_error = "เบอร์โทรหรือรหัสผ่านไม่ถูกต้อง";
            setTimeout(() => (this.alert_error = false), 5000);
          }
        });
      }
    },
    async recallInvoice() {
      let data = this.$store.state.invoiceDetail;
      this.telephone = data.invoice.tel_number;
      this.customer_name = data.invoice.member_name;
      this.payment_data = {
        customer_id: data.invoice.customer_id,
        customer_name: data.invoice.member_name,
        customer_tel: data.invoice.tel_number,
        customer_point: data.invoice.point,
        use_point: 0,
        payment_cash: data.invoice.cash,
        payment_pay: data.invoice.payment,
        payment_qrcode: data.invoice.qrcode_pay,
        payment_credit: data.invoice.credit,
        payment_other: data.invoice.etc_payment,
        pay_note: data.invoice.pay_note != null ? data.invoice.pay_note : null,
        reason: data.invoice.reason != null ? data.invoice.reason : null,
      };
      data.invoice_list.forEach((item) => {
        this.product_data.push({
          id: item.id,
          barcode: item.barcode,
          product_code: item.product_code,
          name: item.product_name,
          unit_id: item.unit_id,
          unit_name: item.unit_name,
          qty_unit: item.unit_qty,
          price_standard: item.price_standard,
          price_standard_old: item.price_standard,
          price_register: item.price_register,
          price_employee: item.price_employee,
          promotion_code: item.promotion_code,
          discount: item.discount,
          qty: item.qty,
          index_group: this.product_data.length,
          total_price: item.total,
          total_price_non: item.total,
        });
      });
      this.discount_last = parseFloat(data.invoice.discount);
      for (let i = 0; i < this.product_data.length; i++) {
        this.summary += parseFloat(this.product_data[i].total_price_non);
        this.discount += parseFloat(
          this.product_data[i].discount == ""
            ? 0
            : this.product_data[i].discount
        );
      }
      this.summary = this.summary + this.discount;
      this.calculate(this.product_data.length - 1);
      this.calculate_last();
      this.$store.state.invoiceDetail.invoice_list = [];
      this.sendMessage();
    },
    reloadPage() {
      window.location.reload();
    },
  },
  async mounted() {
    this.loading_page_global = true; // เปิด loading ครั้งแรก
    if (this.$store.state.socket_list?.socket_code) {
      this.socket_code = this.$store.state.socket_list.socket_code;
      this.$store.commit("getSocket", {
        socket_code: this.socket_code,
        store_name: this.store_name,
        credit_percent: this.credit_charge * 100,
      });
      this.socket = io(process.env.VUE_APP_ARIN_BASE_URL.replace("/api", ""));
      this.socket.on(this.socket_code, (msg) => {
        this.messages.push({ text: msg });
      });
    } else {
      this.socket_code = this.genarateSocketCode(6);
      this.$store.commit("getSocket", {
        socket_code: this.socket_code,
        store_name: this.store_name,
        credit_percent: this.credit_charge * 100,
      });
      this.socket = io(process.env.VUE_APP_ARIN_BASE_URL.replace("/api", ""));
      this.socket.on(this.socket_code, (msg) => {
        this.messages.push({ text: msg });
      });
    }
    await this.sendMessage();

    try {
      await Promise.all([
        this.getCustomer(),
        this.getAddress_api(),
        this.getStatusRoandSell(),
        this.userList(),
        this.getProductList(),
        this.vatType(),
        this.creditList(),
      ]);
    } catch (error) {
      console.error("Error loading initial data:", error);
    } finally {
      this.loading_page_global = false; // ปิด loading เมื่อโหลดทุก API เสร็จ
    }
    if (this.$store.state.invoiceDetail != null) {
      await this.recallInvoice();
    }
    await fetch("https://api64.ipify.org?format=json")
      .then(async (response) => response.json())
      .then(async (res) => {
        this.ip = res.ip;
      })
      .catch((error) => {
        console.error("Error fetching IP address:", error);
      });
  },
  watch: {
    async product_type_list() {
      this.getProductList();
    },
    async telephone() {
      this.getCheckUser(this.telephone);
    },
    async product_value() {
      if (this.product_value != null) {
        const product = this.productList.find(item => item.barcode === this.product_value);
        if (product) {
          this.addItem(this.product_value);
        }
      }
    },
   
    async vat_selection() {
      this.vat_type = await this.vat_selection;
      await this.calculate_last();
      await this.sendMessage();
    },
  },
  beforeDestroy() {
    if (this.socket) {
      this.sendMessage();
      this.socket.disconnect();
    }
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

.w-10px {
  width: 10px !important;
}

.w-45px {
  width: 45px !important;
}

.v-card.active-tab-cash {
  border: 1px solid #b0886b;
}

.v-card .active-tab-cash-text {
  color: #b0886b;
}

.btn_add_data_pop {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 135px !important;
}

.btn_add_data_pop_danger {
  font-size: 16px;
  border-radius: 10px;
  width: 135px !important;
}

.v-list .v-list-item {
  border: 1px solid #d6bfaf;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  margin-bottom: 10px;
}

.v-list .v-list-item--active {
  background-color: #d6bfaf !important;
  border-radius: 15px;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.v-list .v-list-item--active .v-list-item__title {
  color: #ffffff !important;
  border-radius: 15px;
}

.v-list .v-list-item__title {
  font-weight: 600;
}

.v-list .v-list-item .v-list-item__content {
  padding-left: 10px;
}

.v-list .v-list-item--active .v-icon {
  color: #fff !important;
}

.v-list .v-list-item .v-icon {
  color: #b0886b;
}

.logo_branch {
  width: 25px;
  margin: auto;
}

.logo_branch > img {
  max-width: 25px;
}

.choice_branch {
  display: flex;
  justify-content: space-between;
}

.text_style_color {
  color: #909090;
}

.text_style_color-white {
  color: #ffffff;
}
</style>
